/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * TDM Deal Registration API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddTicketMessageRequest,
  AdminSettings,
  AdminUser,
  ApplyReplySuggestionRequest,
  ApplyReplySuggestionResult,
  BuiltInMcpStatus,
  BulkAddCatalogProductsRequest,
  BulkAddCatalogProductsResult,
  BulkImportRequest,
  BulkImportSalesforceSuppliers200,
  CatalogProduct,
  ChannelManagerOverrideRequest,
  CheckSupplierDuplicates200,
  CopyOnRegPref,
  CreateCatalogProductRequest,
  CreateDealRequest,
  CreateExternalMcpServerRequest,
  CreateMcpTokenRequest,
  CreateMcpTokenResult,
  CreateSavedFilterRequest,
  CreateSupplierRequest,
  CreateSupportTicketRequest,
  DashboardSummary,
  DbHealthSnapshot,
  Deal,
  DealWithRegistrations,
  DeleteExternalMcpServer200,
  DeleteSalesforceConfig200,
  DemoDataResetResult,
  EmailPreview,
  EmailProviderConfig,
  ExportRegistrationsCsvParams,
  ExternalMcpServer,
  ExternalMcpTestResult,
  GetDashboardSummaryParams,
  GetMailboxOauthRedirects200,
  GetMailboxOauthStatus200,
  GetRecentActivity200,
  GetRecentActivityParams,
  GetRegistrationJobStatus200,
  GetReportFollowUpImpactParams,
  GetReportPipelineByMonthParams,
  GetReportRegistrationsOverTimeParams,
  GetReportRepPerformanceParams,
  GetReportSupplierLeaderboardParams,
  GetReportTimingParams,
  HealthStatus,
  ListAllTicketsParams,
  ListAuditLogParams,
  ListAuditLogResult,
  ListDeals200,
  ListDealsParams,
  ListRegistrationJobStatusesParams,
  ListRegistrations200,
  ListRegistrationsParams,
  ListSalesforceAccountsForImport200,
  ListSalesforceAccountsForImportParams,
  ListSavedFilters200,
  ListSuppliers200,
  ListSuppliersParams,
  ListTemplates200,
  ListTemplatesParams,
  MailboxConnection,
  MailboxPollHealthReport,
  MatchCheckRequest,
  McpToken,
  Me,
  MergeSupplierRequest,
  NotifyRepForRegistration200,
  PreviewBulkAddCatalogProductsResult,
  PreviewOneRequest,
  Registration,
  RegistrationDetail,
  RegistrationJobStatusMap,
  ReportFollowUpImpact,
  ReportPipelineByMonth,
  ReportRegistrationsOverTime,
  ReportRepPerformance,
  ReportSupplierLeaderboard,
  ReportTiming,
  RequestSupplierSfAdd200,
  RetryRegistrationSend200,
  RevokeMcpToken200,
  RunScheduledReportRequest,
  RunScheduledReportResult,
  SalesforceAuthCheckResult,
  SalesforceAuthHealth,
  SalesforceConfig,
  SalesforceConfigInput,
  SalesforceOpportunity,
  SalesforceStatus,
  SalesforceTestRequest,
  SalesforceTestResult,
  SavedFilter,
  SearchChannelManagers200,
  SearchChannelManagersParams,
  SearchSalesforceOpportunities200,
  SearchSalesforceOpportunitiesParams,
  SendError,
  SendFollowUpRequest,
  SendOneRequest,
  SendOneResponse,
  SendSessionSummaryRequest,
  SendSessionSummaryResult,
  SfFieldCheckReport,
  StartMailboxOauth200,
  StartMailboxOauthParams,
  Supplier,
  SupportEmailPref,
  SupportTicket,
  SupportTicketDetail,
  SupportTicketMessage,
  SystemHealthReport,
  TdmSupplier,
  TechnologyTemplate,
  TemplatePreviewSendRequest,
  TemplatePreviewSendResponse,
  TemplateRequest,
  TestEmailSendRequest,
  TestEmailSendResult,
  UpdateAdminSettingsRequest,
  UpdateAdminUserRequest,
  UpdateCatalogProductRequest,
  UpdateCopyOnRegPrefRequest,
  UpdateEmailProviderConfigRequest,
  UpdateExternalMcpServerRequest,
  UpdateRegistrationRequest,
  UpdateSavedFilterRequest,
  UpdateSupplierRequest,
  UpdateTicketStatusRequest,
  UploadUrlRequest,
  UploadUrlResult,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the current signed-in user
 */
export const getGetMeUrl = () => {
  return `/api/me`;
};

export const getMe = async (options?: RequestInit): Promise<Me> => {
  return customFetch<Me>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<unknown>;

/**
 * @summary Get the current signed-in user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the current user's copy-on-registration preference
 */
export const getGetCopyOnRegPrefUrl = () => {
  return `/api/me/copy-pref`;
};

export const getCopyOnRegPref = async (
  options?: RequestInit,
): Promise<CopyOnRegPref> => {
  return customFetch<CopyOnRegPref>(getGetCopyOnRegPrefUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCopyOnRegPrefQueryKey = () => {
  return [`/api/me/copy-pref`] as const;
};

export const getGetCopyOnRegPrefQueryOptions = <
  TData = Awaited<ReturnType<typeof getCopyOnRegPref>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCopyOnRegPref>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCopyOnRegPrefQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCopyOnRegPref>>
  > = ({ signal }) => getCopyOnRegPref({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCopyOnRegPref>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCopyOnRegPrefQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCopyOnRegPref>>
>;
export type GetCopyOnRegPrefQueryError = ErrorType<unknown>;

/**
 * @summary Get the current user's copy-on-registration preference
 */

export function useGetCopyOnRegPref<
  TData = Awaited<ReturnType<typeof getCopyOnRegPref>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCopyOnRegPref>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCopyOnRegPrefQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the current user's copy-on-registration preference
 */
export const getUpdateCopyOnRegPrefUrl = () => {
  return `/api/me/copy-pref`;
};

export const updateCopyOnRegPref = async (
  updateCopyOnRegPrefRequest: UpdateCopyOnRegPrefRequest,
  options?: RequestInit,
): Promise<CopyOnRegPref> => {
  return customFetch<CopyOnRegPref>(getUpdateCopyOnRegPrefUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCopyOnRegPrefRequest),
  });
};

export const getUpdateCopyOnRegPrefMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCopyOnRegPref>>,
    TError,
    { data: BodyType<UpdateCopyOnRegPrefRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCopyOnRegPref>>,
  TError,
  { data: BodyType<UpdateCopyOnRegPrefRequest> },
  TContext
> => {
  const mutationKey = ["updateCopyOnRegPref"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCopyOnRegPref>>,
    { data: BodyType<UpdateCopyOnRegPrefRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateCopyOnRegPref(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCopyOnRegPrefMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCopyOnRegPref>>
>;
export type UpdateCopyOnRegPrefMutationBody =
  BodyType<UpdateCopyOnRegPrefRequest>;
export type UpdateCopyOnRegPrefMutationError = ErrorType<unknown>;

/**
 * @summary Update the current user's copy-on-registration preference
 */
export const useUpdateCopyOnRegPref = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCopyOnRegPref>>,
    TError,
    { data: BodyType<UpdateCopyOnRegPrefRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCopyOnRegPref>>,
  TError,
  { data: BodyType<UpdateCopyOnRegPrefRequest> },
  TContext
> => {
  return useMutation(getUpdateCopyOnRegPrefMutationOptions(options));
};

/**
 * @summary Get the current user's support ticket email notification preference
 */
export const getGetSupportEmailPrefUrl = () => {
  return `/api/me/support-email-pref`;
};

export const getSupportEmailPref = async (
  options?: RequestInit,
): Promise<SupportEmailPref> => {
  return customFetch<SupportEmailPref>(getGetSupportEmailPrefUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSupportEmailPrefQueryKey = () => {
  return [`/api/me/support-email-pref`] as const;
};

export const getGetSupportEmailPrefQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportEmailPref>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSupportEmailPref>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportEmailPrefQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSupportEmailPref>>
  > = ({ signal }) => getSupportEmailPref({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportEmailPref>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSupportEmailPrefQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportEmailPref>>
>;
export type GetSupportEmailPrefQueryError = ErrorType<unknown>;

/**
 * @summary Get the current user's support ticket email notification preference
 */

export function useGetSupportEmailPref<
  TData = Awaited<ReturnType<typeof getSupportEmailPref>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSupportEmailPref>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSupportEmailPrefQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the current user's support ticket email notification preference
 */
export const getUpdateSupportEmailPrefUrl = () => {
  return `/api/me/support-email-pref`;
};

export const updateSupportEmailPref = async (
  supportEmailPref: SupportEmailPref,
  options?: RequestInit,
): Promise<SupportEmailPref> => {
  return customFetch<SupportEmailPref>(getUpdateSupportEmailPrefUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(supportEmailPref),
  });
};

export const getUpdateSupportEmailPrefMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupportEmailPref>>,
    TError,
    { data: BodyType<SupportEmailPref> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSupportEmailPref>>,
  TError,
  { data: BodyType<SupportEmailPref> },
  TContext
> => {
  const mutationKey = ["updateSupportEmailPref"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSupportEmailPref>>,
    { data: BodyType<SupportEmailPref> }
  > = (props) => {
    const { data } = props ?? {};

    return updateSupportEmailPref(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSupportEmailPrefMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSupportEmailPref>>
>;
export type UpdateSupportEmailPrefMutationBody = BodyType<SupportEmailPref>;
export type UpdateSupportEmailPrefMutationError = ErrorType<unknown>;

/**
 * @summary Update the current user's support ticket email notification preference
 */
export const useUpdateSupportEmailPref = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupportEmailPref>>,
    TError,
    { data: BodyType<SupportEmailPref> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSupportEmailPref>>,
  TError,
  { data: BodyType<SupportEmailPref> },
  TContext
> => {
  return useMutation(getUpdateSupportEmailPrefMutationOptions(options));
};

/**
 * @summary Get the current user's connected mailbox
 */
export const getGetMailboxUrl = () => {
  return `/api/mailbox`;
};

export const getMailbox = async (
  options?: RequestInit,
): Promise<MailboxConnection> => {
  return customFetch<MailboxConnection>(getGetMailboxUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMailboxQueryKey = () => {
  return [`/api/mailbox`] as const;
};

export const getGetMailboxQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailbox>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailbox>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMailboxQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailbox>>> = ({
    signal,
  }) => getMailbox({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailbox>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailbox>>
>;
export type GetMailboxQueryError = ErrorType<unknown>;

/**
 * @summary Get the current user's connected mailbox
 */

export function useGetMailbox<
  TData = Awaited<ReturnType<typeof getMailbox>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailbox>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailboxQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Disconnect the current user's mailbox
 */
export const getDisconnectMailboxUrl = () => {
  return `/api/mailbox`;
};

export const disconnectMailbox = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDisconnectMailboxUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDisconnectMailboxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectMailbox>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectMailbox>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectMailbox>>,
    void
  > = () => {
    return disconnectMailbox(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectMailbox>>
>;

export type DisconnectMailboxMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect the current user's mailbox
 */
export const useDisconnectMailbox = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectMailbox>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectMailbox>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectMailboxMutationOptions(options));
};

/**
 * @summary Admin-only mailbox polling health snapshot
 */
export const getGetMailboxPollHealthUrl = () => {
  return `/api/mailbox/poll-health`;
};

export const getMailboxPollHealth = async (
  options?: RequestInit,
): Promise<MailboxPollHealthReport> => {
  return customFetch<MailboxPollHealthReport>(getGetMailboxPollHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMailboxPollHealthQueryKey = () => {
  return [`/api/mailbox/poll-health`] as const;
};

export const getGetMailboxPollHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailboxPollHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxPollHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMailboxPollHealthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailboxPollHealth>>
  > = ({ signal }) => getMailboxPollHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxPollHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailboxPollHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailboxPollHealth>>
>;
export type GetMailboxPollHealthQueryError = ErrorType<unknown>;

/**
 * @summary Admin-only mailbox polling health snapshot
 */

export function useGetMailboxPollHealth<
  TData = Awaited<ReturnType<typeof getMailboxPollHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxPollHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailboxPollHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Admin-only check of which mailbox OAuth providers are configured
 */
export const getGetMailboxOauthStatusUrl = () => {
  return `/api/mailbox/oauth/status`;
};

export const getMailboxOauthStatus = async (
  options?: RequestInit,
): Promise<GetMailboxOauthStatus200> => {
  return customFetch<GetMailboxOauthStatus200>(getGetMailboxOauthStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMailboxOauthStatusQueryKey = () => {
  return [`/api/mailbox/oauth/status`] as const;
};

export const getGetMailboxOauthStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailboxOauthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMailboxOauthStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailboxOauthStatus>>
  > = ({ signal }) => getMailboxOauthStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailboxOauthStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailboxOauthStatus>>
>;
export type GetMailboxOauthStatusQueryError = ErrorType<unknown>;

/**
 * @summary Admin-only check of which mailbox OAuth providers are configured
 */

export function useGetMailboxOauthStatus<
  TData = Awaited<ReturnType<typeof getMailboxOauthStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailboxOauthStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Start OAuth flow for a mailbox provider
 */
export const getStartMailboxOauthUrl = (params: StartMailboxOauthParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mailbox/oauth/start?${stringifiedParams}`
    : `/api/mailbox/oauth/start`;
};

export const startMailboxOauth = async (
  params: StartMailboxOauthParams,
  options?: RequestInit,
): Promise<StartMailboxOauth200> => {
  return customFetch<StartMailboxOauth200>(getStartMailboxOauthUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getStartMailboxOauthQueryKey = (
  params?: StartMailboxOauthParams,
) => {
  return [`/api/mailbox/oauth/start`, ...(params ? [params] : [])] as const;
};

export const getStartMailboxOauthQueryOptions = <
  TData = Awaited<ReturnType<typeof startMailboxOauth>>,
  TError = ErrorType<unknown>,
>(
  params: StartMailboxOauthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof startMailboxOauth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStartMailboxOauthQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startMailboxOauth>>
  > = ({ signal }) => startMailboxOauth(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startMailboxOauth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StartMailboxOauthQueryResult = NonNullable<
  Awaited<ReturnType<typeof startMailboxOauth>>
>;
export type StartMailboxOauthQueryError = ErrorType<unknown>;

/**
 * @summary Start OAuth flow for a mailbox provider
 */

export function useStartMailboxOauth<
  TData = Awaited<ReturnType<typeof startMailboxOauth>>,
  TError = ErrorType<unknown>,
>(
  params: StartMailboxOauthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof startMailboxOauth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStartMailboxOauthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the exact redirect URIs that admins must register in the Google Cloud Console and Azure App Registration. Admin-only.
 * @summary Get the OAuth callback redirect URIs for mailbox providers
 */
export const getGetMailboxOauthRedirectsUrl = () => {
  return `/api/mailbox/oauth/redirects`;
};

export const getMailboxOauthRedirects = async (
  options?: RequestInit,
): Promise<GetMailboxOauthRedirects200> => {
  return customFetch<GetMailboxOauthRedirects200>(
    getGetMailboxOauthRedirectsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMailboxOauthRedirectsQueryKey = () => {
  return [`/api/mailbox/oauth/redirects`] as const;
};

export const getGetMailboxOauthRedirectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailboxOauthRedirects>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthRedirects>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMailboxOauthRedirectsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailboxOauthRedirects>>
  > = ({ signal }) => getMailboxOauthRedirects({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthRedirects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailboxOauthRedirectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailboxOauthRedirects>>
>;
export type GetMailboxOauthRedirectsQueryError = ErrorType<unknown>;

/**
 * @summary Get the OAuth callback redirect URIs for mailbox providers
 */

export function useGetMailboxOauthRedirects<
  TData = Awaited<ReturnType<typeof getMailboxOauthRedirects>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailboxOauthRedirects>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailboxOauthRedirectsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Check Salesforce connectivity
 */
export const getGetSalesforceStatusUrl = () => {
  return `/api/salesforce/status`;
};

export const getSalesforceStatus = async (
  options?: RequestInit,
): Promise<SalesforceStatus> => {
  return customFetch<SalesforceStatus>(getGetSalesforceStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSalesforceStatusQueryKey = () => {
  return [`/api/salesforce/status`] as const;
};

export const getGetSalesforceStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesforceStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSalesforceStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSalesforceStatus>>
  > = ({ signal }) => getSalesforceStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSalesforceStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesforceStatus>>
>;
export type GetSalesforceStatusQueryError = ErrorType<unknown>;

/**
 * @summary Check Salesforce connectivity
 */

export function useGetSalesforceStatus<
  TData = Awaited<ReturnType<typeof getSalesforceStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSalesforceStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Last persisted Salesforce auth-health check result
 */
export const getGetSalesforceAuthHealthUrl = () => {
  return `/api/salesforce/health`;
};

export const getSalesforceAuthHealth = async (
  options?: RequestInit,
): Promise<SalesforceAuthHealth> => {
  return customFetch<SalesforceAuthHealth>(getGetSalesforceAuthHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSalesforceAuthHealthQueryKey = () => {
  return [`/api/salesforce/health`] as const;
};

export const getGetSalesforceAuthHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesforceAuthHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceAuthHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSalesforceAuthHealthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSalesforceAuthHealth>>
  > = ({ signal }) => getSalesforceAuthHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceAuthHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSalesforceAuthHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesforceAuthHealth>>
>;
export type GetSalesforceAuthHealthQueryError = ErrorType<unknown>;

/**
 * @summary Last persisted Salesforce auth-health check result
 */

export function useGetSalesforceAuthHealth<
  TData = Awaited<ReturnType<typeof getSalesforceAuthHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceAuthHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSalesforceAuthHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trigger an immediate Salesforce auth-health ping
 */
export const getRunSalesforceAuthHealthCheckUrl = () => {
  return `/api/salesforce/health/check`;
};

export const runSalesforceAuthHealthCheck = async (
  options?: RequestInit,
): Promise<SalesforceAuthCheckResult> => {
  return customFetch<SalesforceAuthCheckResult>(
    getRunSalesforceAuthHealthCheckUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRunSalesforceAuthHealthCheckMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["runSalesforceAuthHealthCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>,
    void
  > = () => {
    return runSalesforceAuthHealthCheck(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunSalesforceAuthHealthCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>
>;

export type RunSalesforceAuthHealthCheckMutationError = ErrorType<unknown>;

/**
 * @summary Trigger an immediate Salesforce auth-health ping
 */
export const useRunSalesforceAuthHealthCheck = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runSalesforceAuthHealthCheck>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRunSalesforceAuthHealthCheckMutationOptions(options));
};

export const getSearchSalesforceOpportunitiesUrl = (
  params: SearchSalesforceOpportunitiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/salesforce/opportunities/search?${stringifiedParams}`
    : `/api/salesforce/opportunities/search`;
};

export const searchSalesforceOpportunities = async (
  params: SearchSalesforceOpportunitiesParams,
  options?: RequestInit,
): Promise<SearchSalesforceOpportunities200> => {
  return customFetch<SearchSalesforceOpportunities200>(
    getSearchSalesforceOpportunitiesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchSalesforceOpportunitiesQueryKey = (
  params?: SearchSalesforceOpportunitiesParams,
) => {
  return [
    `/api/salesforce/opportunities/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchSalesforceOpportunitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSalesforceOpportunities>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSalesforceOpportunitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchSalesforceOpportunities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchSalesforceOpportunitiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchSalesforceOpportunities>>
  > = ({ signal }) =>
    searchSalesforceOpportunities(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchSalesforceOpportunities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchSalesforceOpportunitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSalesforceOpportunities>>
>;
export type SearchSalesforceOpportunitiesQueryError = ErrorType<unknown>;

export function useSearchSalesforceOpportunities<
  TData = Awaited<ReturnType<typeof searchSalesforceOpportunities>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSalesforceOpportunitiesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchSalesforceOpportunities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchSalesforceOpportunitiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetSalesforceOpportunityUrl = (id: string) => {
  return `/api/salesforce/opportunities/${id}`;
};

export const getSalesforceOpportunity = async (
  id: string,
  options?: RequestInit,
): Promise<SalesforceOpportunity> => {
  return customFetch<SalesforceOpportunity>(
    getGetSalesforceOpportunityUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSalesforceOpportunityQueryKey = (id: string) => {
  return [`/api/salesforce/opportunities/${id}`] as const;
};

export const getGetSalesforceOpportunityQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesforceOpportunity>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSalesforceOpportunity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSalesforceOpportunityQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSalesforceOpportunity>>
  > = ({ signal }) =>
    getSalesforceOpportunity(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceOpportunity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSalesforceOpportunityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesforceOpportunity>>
>;
export type GetSalesforceOpportunityQueryError = ErrorType<unknown>;

export function useGetSalesforceOpportunity<
  TData = Awaited<ReturnType<typeof getSalesforceOpportunity>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSalesforceOpportunity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSalesforceOpportunityQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSearchChannelManagersUrl = (
  params?: SearchChannelManagersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/salesforce/channel-managers?${stringifiedParams}`
    : `/api/salesforce/channel-managers`;
};

export const searchChannelManagers = async (
  params?: SearchChannelManagersParams,
  options?: RequestInit,
): Promise<SearchChannelManagers200> => {
  return customFetch<SearchChannelManagers200>(
    getSearchChannelManagersUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchChannelManagersQueryKey = (
  params?: SearchChannelManagersParams,
) => {
  return [
    `/api/salesforce/channel-managers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchChannelManagersQueryOptions = <
  TData = Awaited<ReturnType<typeof searchChannelManagers>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchChannelManagersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchChannelManagers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchChannelManagersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchChannelManagers>>
  > = ({ signal }) =>
    searchChannelManagers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchChannelManagers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchChannelManagersQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchChannelManagers>>
>;
export type SearchChannelManagersQueryError = ErrorType<unknown>;

export function useSearchChannelManagers<
  TData = Awaited<ReturnType<typeof searchChannelManagers>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchChannelManagersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchChannelManagers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchChannelManagersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current Salesforce configuration (admin only, private key masked)
 */
export const getGetSalesforceConfigUrl = () => {
  return `/api/salesforce/config`;
};

export const getSalesforceConfig = async (
  options?: RequestInit,
): Promise<SalesforceConfig> => {
  return customFetch<SalesforceConfig>(getGetSalesforceConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSalesforceConfigQueryKey = () => {
  return [`/api/salesforce/config`] as const;
};

export const getGetSalesforceConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesforceConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSalesforceConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSalesforceConfig>>
  > = ({ signal }) => getSalesforceConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSalesforceConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalesforceConfig>>
>;
export type GetSalesforceConfigQueryError = ErrorType<unknown>;

/**
 * @summary Get current Salesforce configuration (admin only, private key masked)
 */

export function useGetSalesforceConfig<
  TData = Awaited<ReturnType<typeof getSalesforceConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSalesforceConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSalesforceConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save or update Salesforce credentials (admin only)
 */
export const getSaveSalesforceConfigUrl = () => {
  return `/api/salesforce/config`;
};

export const saveSalesforceConfig = async (
  salesforceConfigInput: SalesforceConfigInput,
  options?: RequestInit,
): Promise<SalesforceConfig> => {
  return customFetch<SalesforceConfig>(getSaveSalesforceConfigUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(salesforceConfigInput),
  });
};

export const getSaveSalesforceConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveSalesforceConfig>>,
    TError,
    { data: BodyType<SalesforceConfigInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveSalesforceConfig>>,
  TError,
  { data: BodyType<SalesforceConfigInput> },
  TContext
> => {
  const mutationKey = ["saveSalesforceConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveSalesforceConfig>>,
    { data: BodyType<SalesforceConfigInput> }
  > = (props) => {
    const { data } = props ?? {};

    return saveSalesforceConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveSalesforceConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveSalesforceConfig>>
>;
export type SaveSalesforceConfigMutationBody = BodyType<SalesforceConfigInput>;
export type SaveSalesforceConfigMutationError = ErrorType<unknown>;

/**
 * @summary Save or update Salesforce credentials (admin only)
 */
export const useSaveSalesforceConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveSalesforceConfig>>,
    TError,
    { data: BodyType<SalesforceConfigInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveSalesforceConfig>>,
  TError,
  { data: BodyType<SalesforceConfigInput> },
  TContext
> => {
  return useMutation(getSaveSalesforceConfigMutationOptions(options));
};

/**
 * @summary Disconnect Salesforce (admin only)
 */
export const getDeleteSalesforceConfigUrl = () => {
  return `/api/salesforce/config`;
};

export const deleteSalesforceConfig = async (
  options?: RequestInit,
): Promise<DeleteSalesforceConfig200> => {
  return customFetch<DeleteSalesforceConfig200>(
    getDeleteSalesforceConfigUrl(),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteSalesforceConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSalesforceConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSalesforceConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteSalesforceConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSalesforceConfig>>,
    void
  > = () => {
    return deleteSalesforceConfig(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSalesforceConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSalesforceConfig>>
>;

export type DeleteSalesforceConfigMutationError = ErrorType<unknown>;

/**
 * @summary Disconnect Salesforce (admin only)
 */
export const useDeleteSalesforceConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSalesforceConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSalesforceConfig>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteSalesforceConfigMutationOptions(options));
};

/**
 * Tests Salesforce credentials against the per-user configuration. If the request body is empty or omits privateKey, the currently-saved per-user credentials are loaded from the database (private key decrypted server-side) and tested as-is. This allows "Test Connection" buttons that don't require re-entering credentials. When Salesforce is configured via SF_* environment variables, those values are used as the fallback instead of per-user database rows.
 * @summary Test Salesforce credentials (authenticated user; per-user config)
 */
export const getTestSalesforceConfigUrl = () => {
  return `/api/salesforce/config/test`;
};

export const testSalesforceConfig = async (
  salesforceTestRequest?: SalesforceTestRequest,
  options?: RequestInit,
): Promise<SalesforceTestResult> => {
  return customFetch<SalesforceTestResult>(getTestSalesforceConfigUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(salesforceTestRequest),
  });
};

export const getTestSalesforceConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSalesforceConfig>>,
    TError,
    { data: BodyType<SalesforceTestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testSalesforceConfig>>,
  TError,
  { data: BodyType<SalesforceTestRequest> },
  TContext
> => {
  const mutationKey = ["testSalesforceConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testSalesforceConfig>>,
    { data: BodyType<SalesforceTestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testSalesforceConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestSalesforceConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof testSalesforceConfig>>
>;
export type TestSalesforceConfigMutationBody = BodyType<SalesforceTestRequest>;
export type TestSalesforceConfigMutationError = ErrorType<unknown>;

/**
 * @summary Test Salesforce credentials (authenticated user; per-user config)
 */
export const useTestSalesforceConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testSalesforceConfig>>,
    TError,
    { data: BodyType<SalesforceTestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testSalesforceConfig>>,
  TError,
  { data: BodyType<SalesforceTestRequest> },
  TContext
> => {
  return useMutation(getTestSalesforceConfigMutationOptions(options));
};

export const getDeleteLocalDealUrl = (id: string) => {
  return `/api/local-deals/${id}`;
};

export const deleteLocalDeal = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLocalDealUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLocalDealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocalDeal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLocalDeal>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteLocalDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLocalDeal>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLocalDeal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLocalDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLocalDeal>>
>;

export type DeleteLocalDealMutationError = ErrorType<unknown>;

export const useDeleteLocalDeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocalDeal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLocalDeal>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteLocalDealMutationOptions(options));
};

/**
 * @summary Check which Salesforce custom fields are resolvable (admin only)
 */
export const getCheckSalesforceFieldMappingUrl = () => {
  return `/api/local-deals/sf-field-check`;
};

export const checkSalesforceFieldMapping = async (
  options?: RequestInit,
): Promise<SfFieldCheckReport> => {
  return customFetch<SfFieldCheckReport>(getCheckSalesforceFieldMappingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCheckSalesforceFieldMappingQueryKey = () => {
  return [`/api/local-deals/sf-field-check`] as const;
};

export const getCheckSalesforceFieldMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof checkSalesforceFieldMapping>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkSalesforceFieldMapping>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckSalesforceFieldMappingQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkSalesforceFieldMapping>>
  > = ({ signal }) =>
    checkSalesforceFieldMapping({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkSalesforceFieldMapping>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckSalesforceFieldMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkSalesforceFieldMapping>>
>;
export type CheckSalesforceFieldMappingQueryError = ErrorType<unknown>;

/**
 * @summary Check which Salesforce custom fields are resolvable (admin only)
 */

export function useCheckSalesforceFieldMapping<
  TData = Awaited<ReturnType<typeof checkSalesforceFieldMapping>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof checkSalesforceFieldMapping>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckSalesforceFieldMappingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the current user's saved filters plus all shared filters
 */
export const getListSavedFiltersUrl = () => {
  return `/api/saved-filters`;
};

export const listSavedFilters = async (
  options?: RequestInit,
): Promise<ListSavedFilters200> => {
  return customFetch<ListSavedFilters200>(getListSavedFiltersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSavedFiltersQueryKey = () => {
  return [`/api/saved-filters`] as const;
};

export const getListSavedFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedFilters>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSavedFiltersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSavedFilters>>
  > = ({ signal }) => listSavedFilters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSavedFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedFilters>>
>;
export type ListSavedFiltersQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's saved filters plus all shared filters
 */

export function useListSavedFilters<
  TData = Awaited<ReturnType<typeof listSavedFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedFilters>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSavedFiltersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new saved filter
 */
export const getCreateSavedFilterUrl = () => {
  return `/api/saved-filters`;
};

export const createSavedFilter = async (
  createSavedFilterRequest: CreateSavedFilterRequest,
  options?: RequestInit,
): Promise<SavedFilter> => {
  return customFetch<SavedFilter>(getCreateSavedFilterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSavedFilterRequest),
  });
};

export const getCreateSavedFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSavedFilter>>,
    TError,
    { data: BodyType<CreateSavedFilterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSavedFilter>>,
  TError,
  { data: BodyType<CreateSavedFilterRequest> },
  TContext
> => {
  const mutationKey = ["createSavedFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSavedFilter>>,
    { data: BodyType<CreateSavedFilterRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createSavedFilter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSavedFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSavedFilter>>
>;
export type CreateSavedFilterMutationBody = BodyType<CreateSavedFilterRequest>;
export type CreateSavedFilterMutationError = ErrorType<unknown>;

/**
 * @summary Create a new saved filter
 */
export const useCreateSavedFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSavedFilter>>,
    TError,
    { data: BodyType<CreateSavedFilterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSavedFilter>>,
  TError,
  { data: BodyType<CreateSavedFilterRequest> },
  TContext
> => {
  return useMutation(getCreateSavedFilterMutationOptions(options));
};

/**
 * @summary Update a saved filter (owner only)
 */
export const getUpdateSavedFilterUrl = (id: string) => {
  return `/api/saved-filters/${id}`;
};

export const updateSavedFilter = async (
  id: string,
  updateSavedFilterRequest: UpdateSavedFilterRequest,
  options?: RequestInit,
): Promise<SavedFilter> => {
  return customFetch<SavedFilter>(getUpdateSavedFilterUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSavedFilterRequest),
  });
};

export const getUpdateSavedFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSavedFilter>>,
    TError,
    { id: string; data: BodyType<UpdateSavedFilterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSavedFilter>>,
  TError,
  { id: string; data: BodyType<UpdateSavedFilterRequest> },
  TContext
> => {
  const mutationKey = ["updateSavedFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSavedFilter>>,
    { id: string; data: BodyType<UpdateSavedFilterRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSavedFilter(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSavedFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSavedFilter>>
>;
export type UpdateSavedFilterMutationBody = BodyType<UpdateSavedFilterRequest>;
export type UpdateSavedFilterMutationError = ErrorType<unknown>;

/**
 * @summary Update a saved filter (owner only)
 */
export const useUpdateSavedFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSavedFilter>>,
    TError,
    { id: string; data: BodyType<UpdateSavedFilterRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSavedFilter>>,
  TError,
  { id: string; data: BodyType<UpdateSavedFilterRequest> },
  TContext
> => {
  return useMutation(getUpdateSavedFilterMutationOptions(options));
};

/**
 * @summary Delete a saved filter (owner only)
 */
export const getDeleteSavedFilterUrl = (id: string) => {
  return `/api/saved-filters/${id}`;
};

export const deleteSavedFilter = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSavedFilterUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSavedFilterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedFilter>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSavedFilter>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSavedFilter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSavedFilter>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSavedFilter(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSavedFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSavedFilter>>
>;

export type DeleteSavedFilterMutationError = ErrorType<unknown>;

/**
 * @summary Delete a saved filter (owner only)
 */
export const useDeleteSavedFilter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSavedFilter>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSavedFilter>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSavedFilterMutationOptions(options));
};

export const getListDealsUrl = (params?: ListDealsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/deals?${stringifiedParams}`
    : `/api/deals`;
};

export const listDeals = async (
  params?: ListDealsParams,
  options?: RequestInit,
): Promise<ListDeals200> => {
  return customFetch<ListDeals200>(getListDealsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListDealsQueryKey = (params?: ListDealsParams) => {
  return [`/api/deals`, ...(params ? [params] : [])] as const;
};

export const getListDealsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDeals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDealsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDealsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeals>>> = ({
    signal,
  }) => listDeals(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDeals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDealsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDeals>>
>;
export type ListDealsQueryError = ErrorType<unknown>;

export function useListDeals<
  TData = Awaited<ReturnType<typeof listDeals>>,
  TError = ErrorType<unknown>,
>(
  params?: ListDealsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listDeals>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDealsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateDealUrl = () => {
  return `/api/deals`;
};

export const createDeal = async (
  createDealRequest: CreateDealRequest,
  options?: RequestInit,
): Promise<Deal> => {
  return customFetch<Deal>(getCreateDealUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createDealRequest),
  });
};

export const getCreateDealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeal>>,
    TError,
    { data: BodyType<CreateDealRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDeal>>,
  TError,
  { data: BodyType<CreateDealRequest> },
  TContext
> => {
  const mutationKey = ["createDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDeal>>,
    { data: BodyType<CreateDealRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createDeal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDeal>>
>;
export type CreateDealMutationBody = BodyType<CreateDealRequest>;
export type CreateDealMutationError = ErrorType<unknown>;

export const useCreateDeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDeal>>,
    TError,
    { data: BodyType<CreateDealRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDeal>>,
  TError,
  { data: BodyType<CreateDealRequest> },
  TContext
> => {
  return useMutation(getCreateDealMutationOptions(options));
};

export const getGetDealUrl = (id: string) => {
  return `/api/deals/${id}`;
};

export const getDeal = async (
  id: string,
  options?: RequestInit,
): Promise<DealWithRegistrations> => {
  return customFetch<DealWithRegistrations>(getGetDealUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetDealQueryKey = (id: string) => {
  return [`/api/deals/${id}`] as const;
};

export const getGetDealQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeal>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDealQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeal>>> = ({
    signal,
  }) => getDeal(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetDealQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeal>>
>;
export type GetDealQueryError = ErrorType<unknown>;

export function useGetDeal<
  TData = Awaited<ReturnType<typeof getDeal>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDeal>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDealQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteDealUrl = (id: string) => {
  return `/api/deals/${id}`;
};

export const deleteDeal = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteDealUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteDealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDeal>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteDeal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDeal>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteDeal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDealMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDeal>>
>;

export type DeleteDealMutationError = ErrorType<unknown>;

export const useDeleteDeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDeal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteDeal>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteDealMutationOptions(options));
};

export const getRefreshDealFromSalesforceUrl = (id: string) => {
  return `/api/deals/${id}/refresh`;
};

export const refreshDealFromSalesforce = async (
  id: string,
  options?: RequestInit,
): Promise<Deal> => {
  return customFetch<Deal>(getRefreshDealFromSalesforceUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRefreshDealFromSalesforceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshDealFromSalesforce>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshDealFromSalesforce>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["refreshDealFromSalesforce"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshDealFromSalesforce>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return refreshDealFromSalesforce(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshDealFromSalesforceMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshDealFromSalesforce>>
>;

export type RefreshDealFromSalesforceMutationError = ErrorType<unknown>;

export const useRefreshDealFromSalesforce = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshDealFromSalesforce>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshDealFromSalesforce>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRefreshDealFromSalesforceMutationOptions(options));
};

export const getPreviewDealRegistrationForSupplierUrl = (id: string) => {
  return `/api/deals/${id}/preview-one`;
};

export const previewDealRegistrationForSupplier = async (
  id: string,
  previewOneRequest: PreviewOneRequest,
  options?: RequestInit,
): Promise<EmailPreview> => {
  return customFetch<EmailPreview>(
    getPreviewDealRegistrationForSupplierUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(previewOneRequest),
    },
  );
};

export const getPreviewDealRegistrationForSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>,
    TError,
    { id: string; data: BodyType<PreviewOneRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>,
  TError,
  { id: string; data: BodyType<PreviewOneRequest> },
  TContext
> => {
  const mutationKey = ["previewDealRegistrationForSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>,
    { id: string; data: BodyType<PreviewOneRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewDealRegistrationForSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewDealRegistrationForSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>
>;
export type PreviewDealRegistrationForSupplierMutationBody =
  BodyType<PreviewOneRequest>;
export type PreviewDealRegistrationForSupplierMutationError =
  ErrorType<unknown>;

export const usePreviewDealRegistrationForSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>,
    TError,
    { id: string; data: BodyType<PreviewOneRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewDealRegistrationForSupplier>>,
  TError,
  { id: string; data: BodyType<PreviewOneRequest> },
  TContext
> => {
  return useMutation(
    getPreviewDealRegistrationForSupplierMutationOptions(options),
  );
};

export const getSendDealRegistrationForSupplierUrl = (id: string) => {
  return `/api/deals/${id}/send-one`;
};

export const sendDealRegistrationForSupplier = async (
  id: string,
  sendOneRequest: SendOneRequest,
  options?: RequestInit,
): Promise<SendOneResponse> => {
  return customFetch<SendOneResponse>(
    getSendDealRegistrationForSupplierUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendOneRequest),
    },
  );
};

export const getSendDealRegistrationForSupplierMutationOptions = <
  TError = ErrorType<SendError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>,
    TError,
    { id: string; data: BodyType<SendOneRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>,
  TError,
  { id: string; data: BodyType<SendOneRequest> },
  TContext
> => {
  const mutationKey = ["sendDealRegistrationForSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>,
    { id: string; data: BodyType<SendOneRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendDealRegistrationForSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendDealRegistrationForSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>
>;
export type SendDealRegistrationForSupplierMutationBody =
  BodyType<SendOneRequest>;
export type SendDealRegistrationForSupplierMutationError = ErrorType<SendError>;

export const useSendDealRegistrationForSupplier = <
  TError = ErrorType<SendError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>,
    TError,
    { id: string; data: BodyType<SendOneRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendDealRegistrationForSupplier>>,
  TError,
  { id: string; data: BodyType<SendOneRequest> },
  TContext
> => {
  return useMutation(
    getSendDealRegistrationForSupplierMutationOptions(options),
  );
};

export const getSendSessionSummaryUrl = (id: string) => {
  return `/api/deals/${id}/send-session-summary`;
};

export const sendSessionSummary = async (
  id: string,
  sendSessionSummaryRequest: SendSessionSummaryRequest,
  options?: RequestInit,
): Promise<SendSessionSummaryResult> => {
  return customFetch<SendSessionSummaryResult>(getSendSessionSummaryUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendSessionSummaryRequest),
  });
};

export const getSendSessionSummaryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSessionSummary>>,
    TError,
    { id: string; data: BodyType<SendSessionSummaryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSessionSummary>>,
  TError,
  { id: string; data: BodyType<SendSessionSummaryRequest> },
  TContext
> => {
  const mutationKey = ["sendSessionSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSessionSummary>>,
    { id: string; data: BodyType<SendSessionSummaryRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendSessionSummary(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendSessionSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSessionSummary>>
>;
export type SendSessionSummaryMutationBody =
  BodyType<SendSessionSummaryRequest>;
export type SendSessionSummaryMutationError = ErrorType<void>;

export const useSendSessionSummary = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSessionSummary>>,
    TError,
    { id: string; data: BodyType<SendSessionSummaryRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendSessionSummary>>,
  TError,
  { id: string; data: BodyType<SendSessionSummaryRequest> },
  TContext
> => {
  return useMutation(getSendSessionSummaryMutationOptions(options));
};

export const getListRegistrationsUrl = (params?: ListRegistrationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/registrations?${stringifiedParams}`
    : `/api/registrations`;
};

export const listRegistrations = async (
  params?: ListRegistrationsParams,
  options?: RequestInit,
): Promise<ListRegistrations200> => {
  return customFetch<ListRegistrations200>(getListRegistrationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListRegistrationsQueryKey = (
  params?: ListRegistrationsParams,
) => {
  return [`/api/registrations`, ...(params ? [params] : [])] as const;
};

export const getListRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRegistrations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRegistrationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRegistrations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRegistrationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRegistrations>>
  > = ({ signal }) => listRegistrations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRegistrations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRegistrations>>
>;
export type ListRegistrationsQueryError = ErrorType<unknown>;

export function useListRegistrations<
  TData = Awaited<ReturnType<typeof listRegistrations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRegistrationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRegistrations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRegistrationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Batch lookup of latest email-send job statuses for the given registrations.
 */
export const getListRegistrationJobStatusesUrl = (
  params: ListRegistrationJobStatusesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/registrations/job-statuses?${stringifiedParams}`
    : `/api/registrations/job-statuses`;
};

export const listRegistrationJobStatuses = async (
  params: ListRegistrationJobStatusesParams,
  options?: RequestInit,
): Promise<RegistrationJobStatusMap> => {
  return customFetch<RegistrationJobStatusMap>(
    getListRegistrationJobStatusesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListRegistrationJobStatusesQueryKey = (
  params?: ListRegistrationJobStatusesParams,
) => {
  return [
    `/api/registrations/job-statuses`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListRegistrationJobStatusesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRegistrationJobStatuses>>,
  TError = ErrorType<unknown>,
>(
  params: ListRegistrationJobStatusesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRegistrationJobStatuses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListRegistrationJobStatusesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRegistrationJobStatuses>>
  > = ({ signal }) =>
    listRegistrationJobStatuses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRegistrationJobStatuses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRegistrationJobStatusesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRegistrationJobStatuses>>
>;
export type ListRegistrationJobStatusesQueryError = ErrorType<unknown>;

/**
 * @summary Batch lookup of latest email-send job statuses for the given registrations.
 */

export function useListRegistrationJobStatuses<
  TData = Awaited<ReturnType<typeof listRegistrationJobStatuses>>,
  TError = ErrorType<unknown>,
>(
  params: ListRegistrationJobStatusesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRegistrationJobStatuses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRegistrationJobStatusesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the latest email-send job status for a single registration.
 */
export const getGetRegistrationJobStatusUrl = (id: string) => {
  return `/api/registrations/${id}/job-status`;
};

export const getRegistrationJobStatus = async (
  id: string,
  options?: RequestInit,
): Promise<GetRegistrationJobStatus200> => {
  return customFetch<GetRegistrationJobStatus200>(
    getGetRegistrationJobStatusUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRegistrationJobStatusQueryKey = (id: string) => {
  return [`/api/registrations/${id}/job-status`] as const;
};

export const getGetRegistrationJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistrationJobStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistrationJobStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRegistrationJobStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegistrationJobStatus>>
  > = ({ signal }) =>
    getRegistrationJobStatus(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegistrationJobStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegistrationJobStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistrationJobStatus>>
>;
export type GetRegistrationJobStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get the latest email-send job status for a single registration.
 */

export function useGetRegistrationJobStatus<
  TData = Awaited<ReturnType<typeof getRegistrationJobStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistrationJobStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegistrationJobStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Retry the latest failed/cancelled email-send job for a registration.
 */
export const getRetryRegistrationSendUrl = (id: string) => {
  return `/api/registrations/${id}/retry-send`;
};

export const retryRegistrationSend = async (
  id: string,
  options?: RequestInit,
): Promise<RetryRegistrationSend200> => {
  return customFetch<RetryRegistrationSend200>(
    getRetryRegistrationSendUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRetryRegistrationSendMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryRegistrationSend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryRegistrationSend>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["retryRegistrationSend"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryRegistrationSend>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return retryRegistrationSend(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryRegistrationSendMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryRegistrationSend>>
>;

export type RetryRegistrationSendMutationError = ErrorType<unknown>;

/**
 * @summary Retry the latest failed/cancelled email-send job for a registration.
 */
export const useRetryRegistrationSend = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryRegistrationSend>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryRegistrationSend>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRetryRegistrationSendMutationOptions(options));
};

export const getGetRegistrationUrl = (id: string) => {
  return `/api/registrations/${id}`;
};

export const getRegistration = async (
  id: string,
  options?: RequestInit,
): Promise<RegistrationDetail> => {
  return customFetch<RegistrationDetail>(getGetRegistrationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetRegistrationQueryKey = (id: string) => {
  return [`/api/registrations/${id}`] as const;
};

export const getGetRegistrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistration>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistration>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegistrationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistration>>> = ({
    signal,
  }) => getRegistration(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegistration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRegistrationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistration>>
>;
export type GetRegistrationQueryError = ErrorType<unknown>;

export function useGetRegistration<
  TData = Awaited<ReturnType<typeof getRegistration>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistration>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRegistrationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateRegistrationStatusUrl = (id: string) => {
  return `/api/registrations/${id}`;
};

export const updateRegistrationStatus = async (
  id: string,
  updateRegistrationRequest: UpdateRegistrationRequest,
  options?: RequestInit,
): Promise<Registration> => {
  return customFetch<Registration>(getUpdateRegistrationStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRegistrationRequest),
  });
};

export const getUpdateRegistrationStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegistrationStatus>>,
    TError,
    { id: string; data: BodyType<UpdateRegistrationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRegistrationStatus>>,
  TError,
  { id: string; data: BodyType<UpdateRegistrationRequest> },
  TContext
> => {
  const mutationKey = ["updateRegistrationStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRegistrationStatus>>,
    { id: string; data: BodyType<UpdateRegistrationRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRegistrationStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRegistrationStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRegistrationStatus>>
>;
export type UpdateRegistrationStatusMutationBody =
  BodyType<UpdateRegistrationRequest>;
export type UpdateRegistrationStatusMutationError = ErrorType<unknown>;

export const useUpdateRegistrationStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegistrationStatus>>,
    TError,
    { id: string; data: BodyType<UpdateRegistrationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRegistrationStatus>>,
  TError,
  { id: string; data: BodyType<UpdateRegistrationRequest> },
  TContext
> => {
  return useMutation(getUpdateRegistrationStatusMutationOptions(options));
};

export const getListTemplatesUrl = (params?: ListTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/templates?${stringifiedParams}`
    : `/api/templates`;
};

export const listTemplates = async (
  params?: ListTemplatesParams,
  options?: RequestInit,
): Promise<ListTemplates200> => {
  return customFetch<ListTemplates200>(getListTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTemplatesQueryKey = (params?: ListTemplatesParams) => {
  return [`/api/templates`, ...(params ? [params] : [])] as const;
};

export const getListTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTemplatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({
    signal,
  }) => listTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTemplates>>
>;
export type ListTemplatesQueryError = ErrorType<unknown>;

export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateTemplateUrl = () => {
  return `/api/templates`;
};

export const createTemplate = async (
  templateRequest: TemplateRequest,
  options?: RequestInit,
): Promise<TechnologyTemplate> => {
  return customFetch<TechnologyTemplate>(getCreateTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(templateRequest),
  });
};

export const getCreateTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { data: BodyType<TemplateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: BodyType<TemplateRequest> },
  TContext
> => {
  const mutationKey = ["createTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplate>>,
    { data: BodyType<TemplateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTemplate>>
>;
export type CreateTemplateMutationBody = BodyType<TemplateRequest>;
export type CreateTemplateMutationError = ErrorType<unknown>;

export const useCreateTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { data: BodyType<TemplateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: BodyType<TemplateRequest> },
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options));
};

export const getGetTemplateUrl = (id: string) => {
  return `/api/templates/${id}`;
};

export const getTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<TechnologyTemplate> => {
  return customFetch<TechnologyTemplate>(getGetTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTemplateQueryKey = (id: string) => {
  return [`/api/templates/${id}`] as const;
};

export const getGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTemplateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateQueryError = ErrorType<unknown>;

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateTemplateUrl = (id: string) => {
  return `/api/templates/${id}`;
};

export const updateTemplate = async (
  id: string,
  templateRequest: TemplateRequest,
  options?: RequestInit,
): Promise<TechnologyTemplate> => {
  return customFetch<TechnologyTemplate>(getUpdateTemplateUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(templateRequest),
  });
};

export const getUpdateTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { id: string; data: BodyType<TemplateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { id: string; data: BodyType<TemplateRequest> },
  TContext
> => {
  const mutationKey = ["updateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTemplate>>,
    { id: string; data: BodyType<TemplateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTemplate>>
>;
export type UpdateTemplateMutationBody = BodyType<TemplateRequest>;
export type UpdateTemplateMutationError = ErrorType<unknown>;

export const useUpdateTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { id: string; data: BodyType<TemplateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { id: string; data: BodyType<TemplateRequest> },
  TContext
> => {
  return useMutation(getUpdateTemplateMutationOptions(options));
};

export const getDeleteTemplateUrl = (id: string) => {
  return `/api/templates/${id}`;
};

export const deleteTemplate = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTemplate>>
>;

export type DeleteTemplateMutationError = ErrorType<unknown>;

export const useDeleteTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTemplateMutationOptions(options));
};

/**
 * @summary Send a rendered preview of the template (using sample merge values) to the logged-in admin's email.
 */
export const getSendTemplatePreviewEmailUrl = () => {
  return `/api/templates/preview-send`;
};

export const sendTemplatePreviewEmail = async (
  templatePreviewSendRequest: TemplatePreviewSendRequest,
  options?: RequestInit,
): Promise<TemplatePreviewSendResponse> => {
  return customFetch<TemplatePreviewSendResponse>(
    getSendTemplatePreviewEmailUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(templatePreviewSendRequest),
    },
  );
};

export const getSendTemplatePreviewEmailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTemplatePreviewEmail>>,
    TError,
    { data: BodyType<TemplatePreviewSendRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTemplatePreviewEmail>>,
  TError,
  { data: BodyType<TemplatePreviewSendRequest> },
  TContext
> => {
  const mutationKey = ["sendTemplatePreviewEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTemplatePreviewEmail>>,
    { data: BodyType<TemplatePreviewSendRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return sendTemplatePreviewEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTemplatePreviewEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTemplatePreviewEmail>>
>;
export type SendTemplatePreviewEmailMutationBody =
  BodyType<TemplatePreviewSendRequest>;
export type SendTemplatePreviewEmailMutationError = ErrorType<unknown>;

/**
 * @summary Send a rendered preview of the template (using sample merge values) to the logged-in admin's email.
 */
export const useSendTemplatePreviewEmail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTemplatePreviewEmail>>,
    TError,
    { data: BodyType<TemplatePreviewSendRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTemplatePreviewEmail>>,
  TError,
  { data: BodyType<TemplatePreviewSendRequest> },
  TContext
> => {
  return useMutation(getSendTemplatePreviewEmailMutationOptions(options));
};

export const getSendRegistrationFollowUpUrl = (id: string) => {
  return `/api/registrations/${id}/follow-up`;
};

export const sendRegistrationFollowUp = async (
  id: string,
  sendFollowUpRequest: SendFollowUpRequest,
  options?: RequestInit,
): Promise<Registration> => {
  return customFetch<Registration>(getSendRegistrationFollowUpUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendFollowUpRequest),
  });
};

export const getSendRegistrationFollowUpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendRegistrationFollowUp>>,
    TError,
    { id: string; data: BodyType<SendFollowUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendRegistrationFollowUp>>,
  TError,
  { id: string; data: BodyType<SendFollowUpRequest> },
  TContext
> => {
  const mutationKey = ["sendRegistrationFollowUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendRegistrationFollowUp>>,
    { id: string; data: BodyType<SendFollowUpRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendRegistrationFollowUp(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendRegistrationFollowUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendRegistrationFollowUp>>
>;
export type SendRegistrationFollowUpMutationBody =
  BodyType<SendFollowUpRequest>;
export type SendRegistrationFollowUpMutationError = ErrorType<unknown>;

export const useSendRegistrationFollowUp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendRegistrationFollowUp>>,
    TError,
    { id: string; data: BodyType<SendFollowUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendRegistrationFollowUp>>,
  TError,
  { id: string; data: BodyType<SendFollowUpRequest> },
  TContext
> => {
  return useMutation(getSendRegistrationFollowUpMutationOptions(options));
};

export const getPreviewRegistrationFollowUpUrl = (id: string) => {
  return `/api/registrations/${id}/follow-up/preview`;
};

export const previewRegistrationFollowUp = async (
  id: string,
  sendFollowUpRequest: SendFollowUpRequest,
  options?: RequestInit,
): Promise<EmailPreview> => {
  return customFetch<EmailPreview>(getPreviewRegistrationFollowUpUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendFollowUpRequest),
  });
};

export const getPreviewRegistrationFollowUpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRegistrationFollowUp>>,
    TError,
    { id: string; data: BodyType<SendFollowUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewRegistrationFollowUp>>,
  TError,
  { id: string; data: BodyType<SendFollowUpRequest> },
  TContext
> => {
  const mutationKey = ["previewRegistrationFollowUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewRegistrationFollowUp>>,
    { id: string; data: BodyType<SendFollowUpRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewRegistrationFollowUp(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewRegistrationFollowUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewRegistrationFollowUp>>
>;
export type PreviewRegistrationFollowUpMutationBody =
  BodyType<SendFollowUpRequest>;
export type PreviewRegistrationFollowUpMutationError = ErrorType<unknown>;

export const usePreviewRegistrationFollowUp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewRegistrationFollowUp>>,
    TError,
    { id: string; data: BodyType<SendFollowUpRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewRegistrationFollowUp>>,
  TError,
  { id: string; data: BodyType<SendFollowUpRequest> },
  TContext
> => {
  return useMutation(getPreviewRegistrationFollowUpMutationOptions(options));
};

export const getNotifyRepForRegistrationUrl = (id: string) => {
  return `/api/registrations/${id}/notify-rep`;
};

export const notifyRepForRegistration = async (
  id: string,
  options?: RequestInit,
): Promise<NotifyRepForRegistration200> => {
  return customFetch<NotifyRepForRegistration200>(
    getNotifyRepForRegistrationUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getNotifyRepForRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notifyRepForRegistration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notifyRepForRegistration>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["notifyRepForRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notifyRepForRegistration>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return notifyRepForRegistration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotifyRepForRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof notifyRepForRegistration>>
>;

export type NotifyRepForRegistrationMutationError = ErrorType<unknown>;

export const useNotifyRepForRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notifyRepForRegistration>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof notifyRepForRegistration>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getNotifyRepForRegistrationMutationOptions(options));
};

/**
 * @summary Apply a supplier reply's suggested status to the registration
 */
export const getApplyReplySuggestionUrl = (id: string, replyId: string) => {
  return `/api/registrations/${id}/replies/${replyId}/apply`;
};

export const applyReplySuggestion = async (
  id: string,
  replyId: string,
  applyReplySuggestionRequest?: ApplyReplySuggestionRequest,
  options?: RequestInit,
): Promise<ApplyReplySuggestionResult> => {
  return customFetch<ApplyReplySuggestionResult>(
    getApplyReplySuggestionUrl(id, replyId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(applyReplySuggestionRequest),
    },
  );
};

export const getApplyReplySuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyReplySuggestion>>,
    TError,
    {
      id: string;
      replyId: string;
      data: BodyType<ApplyReplySuggestionRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyReplySuggestion>>,
  TError,
  { id: string; replyId: string; data: BodyType<ApplyReplySuggestionRequest> },
  TContext
> => {
  const mutationKey = ["applyReplySuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyReplySuggestion>>,
    { id: string; replyId: string; data: BodyType<ApplyReplySuggestionRequest> }
  > = (props) => {
    const { id, replyId, data } = props ?? {};

    return applyReplySuggestion(id, replyId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyReplySuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyReplySuggestion>>
>;
export type ApplyReplySuggestionMutationBody =
  BodyType<ApplyReplySuggestionRequest>;
export type ApplyReplySuggestionMutationError = ErrorType<unknown>;

/**
 * @summary Apply a supplier reply's suggested status to the registration
 */
export const useApplyReplySuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyReplySuggestion>>,
    TError,
    {
      id: string;
      replyId: string;
      data: BodyType<ApplyReplySuggestionRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyReplySuggestion>>,
  TError,
  { id: string; replyId: string; data: BodyType<ApplyReplySuggestionRequest> },
  TContext
> => {
  return useMutation(getApplyReplySuggestionMutationOptions(options));
};

export const getGetDashboardSummaryUrl = (
  params?: GetDashboardSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/summary?${stringifiedParams}`
    : `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  params?: GetDashboardSummaryParams,
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = (
  params?: GetDashboardSummaryParams,
) => {
  return [`/api/dashboard/summary`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) =>
    getDashboardSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetRecentActivityUrl = (params?: GetRecentActivityParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/activity?${stringifiedParams}`
    : `/api/dashboard/activity`;
};

export const getRecentActivity = async (
  params?: GetRecentActivityParams,
  options?: RequestInit,
): Promise<GetRecentActivity200> => {
  return customFetch<GetRecentActivity200>(getGetRecentActivityUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentActivityQueryKey = (
  params?: GetRecentActivityParams,
) => {
  return [`/api/dashboard/activity`, ...(params ? [params] : [])] as const;
};

export const getGetRecentActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRecentActivityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentActivity>>
  > = ({ signal }) => getRecentActivity(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentActivity>>
>;
export type GetRecentActivityQueryError = ErrorType<unknown>;

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(
  params?: GetRecentActivityParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecentActivity>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentActivityQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Registrations grouped by day and status (admin only)
 */
export const getGetReportRegistrationsOverTimeUrl = (
  params?: GetReportRegistrationsOverTimeParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/registrations-over-time?${stringifiedParams}`
    : `/api/dashboard/reports/registrations-over-time`;
};

export const getReportRegistrationsOverTime = async (
  params?: GetReportRegistrationsOverTimeParams,
  options?: RequestInit,
): Promise<ReportRegistrationsOverTime> => {
  return customFetch<ReportRegistrationsOverTime>(
    getGetReportRegistrationsOverTimeUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReportRegistrationsOverTimeQueryKey = (
  params?: GetReportRegistrationsOverTimeParams,
) => {
  return [
    `/api/dashboard/reports/registrations-over-time`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportRegistrationsOverTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportRegistrationsOverTime>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportRegistrationsOverTimeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportRegistrationsOverTime>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportRegistrationsOverTimeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportRegistrationsOverTime>>
  > = ({ signal }) =>
    getReportRegistrationsOverTime(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportRegistrationsOverTime>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportRegistrationsOverTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportRegistrationsOverTime>>
>;
export type GetReportRegistrationsOverTimeQueryError = ErrorType<unknown>;

/**
 * @summary Registrations grouped by day and status (admin only)
 */

export function useGetReportRegistrationsOverTime<
  TData = Awaited<ReturnType<typeof getReportRegistrationsOverTime>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportRegistrationsOverTimeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportRegistrationsOverTime>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportRegistrationsOverTimeQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Top suppliers by registration volume and approval rate (admin only)
 */
export const getGetReportSupplierLeaderboardUrl = (
  params?: GetReportSupplierLeaderboardParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/supplier-leaderboard?${stringifiedParams}`
    : `/api/dashboard/reports/supplier-leaderboard`;
};

export const getReportSupplierLeaderboard = async (
  params?: GetReportSupplierLeaderboardParams,
  options?: RequestInit,
): Promise<ReportSupplierLeaderboard> => {
  return customFetch<ReportSupplierLeaderboard>(
    getGetReportSupplierLeaderboardUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReportSupplierLeaderboardQueryKey = (
  params?: GetReportSupplierLeaderboardParams,
) => {
  return [
    `/api/dashboard/reports/supplier-leaderboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportSupplierLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportSupplierLeaderboard>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportSupplierLeaderboardParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportSupplierLeaderboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportSupplierLeaderboardQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportSupplierLeaderboard>>
  > = ({ signal }) =>
    getReportSupplierLeaderboard(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportSupplierLeaderboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportSupplierLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportSupplierLeaderboard>>
>;
export type GetReportSupplierLeaderboardQueryError = ErrorType<unknown>;

/**
 * @summary Top suppliers by registration volume and approval rate (admin only)
 */

export function useGetReportSupplierLeaderboard<
  TData = Awaited<ReturnType<typeof getReportSupplierLeaderboard>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportSupplierLeaderboardParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportSupplierLeaderboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportSupplierLeaderboardQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Time-to-reply distribution (admin only)
 */
export const getGetReportTimingUrl = (params?: GetReportTimingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/timing?${stringifiedParams}`
    : `/api/dashboard/reports/timing`;
};

export const getReportTiming = async (
  params?: GetReportTimingParams,
  options?: RequestInit,
): Promise<ReportTiming> => {
  return customFetch<ReportTiming>(getGetReportTimingUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetReportTimingQueryKey = (params?: GetReportTimingParams) => {
  return [
    `/api/dashboard/reports/timing`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportTimingQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportTiming>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportTimingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportTiming>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportTimingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportTiming>>> = ({
    signal,
  }) => getReportTiming(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportTiming>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportTimingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportTiming>>
>;
export type GetReportTimingQueryError = ErrorType<unknown>;

/**
 * @summary Time-to-reply distribution (admin only)
 */

export function useGetReportTiming<
  TData = Awaited<ReturnType<typeof getReportTiming>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportTimingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportTiming>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportTimingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Reply rate with vs without follow-up (admin only)
 */
export const getGetReportFollowUpImpactUrl = (
  params?: GetReportFollowUpImpactParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/follow-up-impact?${stringifiedParams}`
    : `/api/dashboard/reports/follow-up-impact`;
};

export const getReportFollowUpImpact = async (
  params?: GetReportFollowUpImpactParams,
  options?: RequestInit,
): Promise<ReportFollowUpImpact> => {
  return customFetch<ReportFollowUpImpact>(
    getGetReportFollowUpImpactUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReportFollowUpImpactQueryKey = (
  params?: GetReportFollowUpImpactParams,
) => {
  return [
    `/api/dashboard/reports/follow-up-impact`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportFollowUpImpactQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportFollowUpImpact>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportFollowUpImpactParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportFollowUpImpact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportFollowUpImpactQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportFollowUpImpact>>
  > = ({ signal }) =>
    getReportFollowUpImpact(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportFollowUpImpact>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportFollowUpImpactQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportFollowUpImpact>>
>;
export type GetReportFollowUpImpactQueryError = ErrorType<unknown>;

/**
 * @summary Reply rate with vs without follow-up (admin only)
 */

export function useGetReportFollowUpImpact<
  TData = Awaited<ReturnType<typeof getReportFollowUpImpact>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportFollowUpImpactParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportFollowUpImpact>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportFollowUpImpactQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-rep registration performance (admin only)
 */
export const getGetReportRepPerformanceUrl = (
  params?: GetReportRepPerformanceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/rep-performance?${stringifiedParams}`
    : `/api/dashboard/reports/rep-performance`;
};

export const getReportRepPerformance = async (
  params?: GetReportRepPerformanceParams,
  options?: RequestInit,
): Promise<ReportRepPerformance> => {
  return customFetch<ReportRepPerformance>(
    getGetReportRepPerformanceUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReportRepPerformanceQueryKey = (
  params?: GetReportRepPerformanceParams,
) => {
  return [
    `/api/dashboard/reports/rep-performance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportRepPerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportRepPerformance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportRepPerformanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportRepPerformance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportRepPerformanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportRepPerformance>>
  > = ({ signal }) =>
    getReportRepPerformance(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportRepPerformance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportRepPerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportRepPerformance>>
>;
export type GetReportRepPerformanceQueryError = ErrorType<unknown>;

/**
 * @summary Per-rep registration performance (admin only)
 */

export function useGetReportRepPerformance<
  TData = Awaited<ReturnType<typeof getReportRepPerformance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportRepPerformanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportRepPerformance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportRepPerformanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Salesforce pipeline value pushed per month (admin only)
 */
export const getGetReportPipelineByMonthUrl = (
  params?: GetReportPipelineByMonthParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/reports/pipeline-by-month?${stringifiedParams}`
    : `/api/dashboard/reports/pipeline-by-month`;
};

export const getReportPipelineByMonth = async (
  params?: GetReportPipelineByMonthParams,
  options?: RequestInit,
): Promise<ReportPipelineByMonth> => {
  return customFetch<ReportPipelineByMonth>(
    getGetReportPipelineByMonthUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetReportPipelineByMonthQueryKey = (
  params?: GetReportPipelineByMonthParams,
) => {
  return [
    `/api/dashboard/reports/pipeline-by-month`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetReportPipelineByMonthQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportPipelineByMonth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportPipelineByMonthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportPipelineByMonth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportPipelineByMonthQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportPipelineByMonth>>
  > = ({ signal }) =>
    getReportPipelineByMonth(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportPipelineByMonth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReportPipelineByMonthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportPipelineByMonth>>
>;
export type GetReportPipelineByMonthQueryError = ErrorType<unknown>;

/**
 * @summary Salesforce pipeline value pushed per month (admin only)
 */

export function useGetReportPipelineByMonth<
  TData = Awaited<ReturnType<typeof getReportPipelineByMonth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetReportPipelineByMonthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReportPipelineByMonth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReportPipelineByMonthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List TDM-managed suppliers (manually added and SF-imported)
 */
export const getListSuppliersUrl = (params?: ListSuppliersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/suppliers?${stringifiedParams}`
    : `/api/suppliers`;
};

export const listSuppliers = async (
  params?: ListSuppliersParams,
  options?: RequestInit,
): Promise<ListSuppliers200> => {
  return customFetch<ListSuppliers200>(getListSuppliersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSuppliersQueryKey = (params?: ListSuppliersParams) => {
  return [`/api/suppliers`, ...(params ? [params] : [])] as const;
};

export const getListSuppliersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSuppliersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({
    signal,
  }) => listSuppliers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSuppliers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSuppliersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSuppliers>>
>;
export type ListSuppliersQueryError = ErrorType<unknown>;

/**
 * @summary List TDM-managed suppliers (manually added and SF-imported)
 */

export function useListSuppliers<
  TData = Awaited<ReturnType<typeof listSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSuppliersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a manual TDM supplier (admin only)
 */
export const getCreateSupplierUrl = () => {
  return `/api/suppliers`;
};

export const createSupplier = async (
  createSupplierRequest: CreateSupplierRequest,
  options?: RequestInit,
): Promise<TdmSupplier> => {
  return customFetch<TdmSupplier>(getCreateSupplierUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSupplierRequest),
  });
};

export const getCreateSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplier>>,
    TError,
    { data: BodyType<CreateSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupplier>>,
  TError,
  { data: BodyType<CreateSupplierRequest> },
  TContext
> => {
  const mutationKey = ["createSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupplier>>,
    { data: BodyType<CreateSupplierRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createSupplier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSupplier>>
>;
export type CreateSupplierMutationBody = BodyType<CreateSupplierRequest>;
export type CreateSupplierMutationError = ErrorType<unknown>;

/**
 * @summary Create a manual TDM supplier (admin only)
 */
export const useCreateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplier>>,
    TError,
    { data: BodyType<CreateSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSupplier>>,
  TError,
  { data: BodyType<CreateSupplierRequest> },
  TContext
> => {
  return useMutation(getCreateSupplierMutationOptions(options));
};

/**
 * @summary List Salesforce partner accounts available for import (admin only)
 */
export const getListSalesforceAccountsForImportUrl = (
  params?: ListSalesforceAccountsForImportParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/suppliers/salesforce-accounts?${stringifiedParams}`
    : `/api/suppliers/salesforce-accounts`;
};

export const listSalesforceAccountsForImport = async (
  params?: ListSalesforceAccountsForImportParams,
  options?: RequestInit,
): Promise<ListSalesforceAccountsForImport200> => {
  return customFetch<ListSalesforceAccountsForImport200>(
    getListSalesforceAccountsForImportUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSalesforceAccountsForImportQueryKey = (
  params?: ListSalesforceAccountsForImportParams,
) => {
  return [
    `/api/suppliers/salesforce-accounts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSalesforceAccountsForImportQueryOptions = <
  TData = Awaited<ReturnType<typeof listSalesforceAccountsForImport>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSalesforceAccountsForImportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSalesforceAccountsForImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSalesforceAccountsForImportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSalesforceAccountsForImport>>
  > = ({ signal }) =>
    listSalesforceAccountsForImport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSalesforceAccountsForImport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSalesforceAccountsForImportQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSalesforceAccountsForImport>>
>;
export type ListSalesforceAccountsForImportQueryError = ErrorType<unknown>;

/**
 * @summary List Salesforce partner accounts available for import (admin only)
 */

export function useListSalesforceAccountsForImport<
  TData = Awaited<ReturnType<typeof listSalesforceAccountsForImport>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSalesforceAccountsForImportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSalesforceAccountsForImport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSalesforceAccountsForImportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Run duplicate match check against existing TDM suppliers (admin only)
 */
export const getCheckSupplierDuplicatesUrl = () => {
  return `/api/suppliers/match-check`;
};

export const checkSupplierDuplicates = async (
  matchCheckRequest: MatchCheckRequest,
  options?: RequestInit,
): Promise<CheckSupplierDuplicates200> => {
  return customFetch<CheckSupplierDuplicates200>(
    getCheckSupplierDuplicatesUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(matchCheckRequest),
    },
  );
};

export const getCheckSupplierDuplicatesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkSupplierDuplicates>>,
    TError,
    { data: BodyType<MatchCheckRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkSupplierDuplicates>>,
  TError,
  { data: BodyType<MatchCheckRequest> },
  TContext
> => {
  const mutationKey = ["checkSupplierDuplicates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkSupplierDuplicates>>,
    { data: BodyType<MatchCheckRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return checkSupplierDuplicates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckSupplierDuplicatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkSupplierDuplicates>>
>;
export type CheckSupplierDuplicatesMutationBody = BodyType<MatchCheckRequest>;
export type CheckSupplierDuplicatesMutationError = ErrorType<unknown>;

/**
 * @summary Run duplicate match check against existing TDM suppliers (admin only)
 */
export const useCheckSupplierDuplicates = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkSupplierDuplicates>>,
    TError,
    { data: BodyType<MatchCheckRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkSupplierDuplicates>>,
  TError,
  { data: BodyType<MatchCheckRequest> },
  TContext
> => {
  return useMutation(getCheckSupplierDuplicatesMutationOptions(options));
};

/**
 * @summary Bulk import Salesforce partner accounts as TDM suppliers (admin only)
 */
export const getBulkImportSalesforceSuppliersUrl = () => {
  return `/api/suppliers/bulk-import`;
};

export const bulkImportSalesforceSuppliers = async (
  bulkImportRequest: BulkImportRequest,
  options?: RequestInit,
): Promise<BulkImportSalesforceSuppliers200> => {
  return customFetch<BulkImportSalesforceSuppliers200>(
    getBulkImportSalesforceSuppliersUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkImportRequest),
    },
  );
};

export const getBulkImportSalesforceSuppliersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>,
    TError,
    { data: BodyType<BulkImportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>,
  TError,
  { data: BodyType<BulkImportRequest> },
  TContext
> => {
  const mutationKey = ["bulkImportSalesforceSuppliers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>,
    { data: BodyType<BulkImportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkImportSalesforceSuppliers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkImportSalesforceSuppliersMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>
>;
export type BulkImportSalesforceSuppliersMutationBody =
  BodyType<BulkImportRequest>;
export type BulkImportSalesforceSuppliersMutationError = ErrorType<unknown>;

/**
 * @summary Bulk import Salesforce partner accounts as TDM suppliers (admin only)
 */
export const useBulkImportSalesforceSuppliers = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>,
    TError,
    { data: BodyType<BulkImportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkImportSalesforceSuppliers>>,
  TError,
  { data: BodyType<BulkImportRequest> },
  TContext
> => {
  return useMutation(getBulkImportSalesforceSuppliersMutationOptions(options));
};

export const getGetSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}`;
};

export const getSupplier = async (
  id: string,
  options?: RequestInit,
): Promise<TdmSupplier> => {
  return customFetch<TdmSupplier>(getGetSupplierUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSupplierQueryKey = (id: string) => {
  return [`/api/suppliers/${id}`] as const;
};

export const getGetSupplierQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplier>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSupplier>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupplierQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupplier>>> = ({
    signal,
  }) => getSupplier(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupplier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSupplierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplier>>
>;
export type GetSupplierQueryError = ErrorType<unknown>;

export function useGetSupplier<
  TData = Awaited<ReturnType<typeof getSupplier>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSupplier>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSupplierQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a TDM supplier (admin only)
 */
export const getUpdateSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}`;
};

export const updateSupplier = async (
  id: string,
  updateSupplierRequest: UpdateSupplierRequest,
  options?: RequestInit,
): Promise<TdmSupplier> => {
  return customFetch<TdmSupplier>(getUpdateSupplierUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSupplierRequest),
  });
};

export const getUpdateSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierRequest> },
  TContext
> => {
  const mutationKey = ["updateSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSupplier>>,
    { id: string; data: BodyType<UpdateSupplierRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSupplier>>
>;
export type UpdateSupplierMutationBody = BodyType<UpdateSupplierRequest>;
export type UpdateSupplierMutationError = ErrorType<unknown>;

/**
 * @summary Update a TDM supplier (admin only)
 */
export const useUpdateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierRequest> },
  TContext
> => {
  return useMutation(getUpdateSupplierMutationOptions(options));
};

/**
 * @summary Delete a TDM supplier (admin only)
 */
export const getDeleteSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}`;
};

export const deleteSupplier = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplier>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSupplier(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplier>>
>;

export type DeleteSupplierMutationError = ErrorType<unknown>;

/**
 * @summary Delete a TDM supplier (admin only)
 */
export const useDeleteSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSupplierMutationOptions(options));
};

/**
 * @summary Merge this supplier into another, soft-deleting this one (admin only)
 */
export const getMergeSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}/merge`;
};

export const mergeSupplier = async (
  id: string,
  mergeSupplierRequest: MergeSupplierRequest,
  options?: RequestInit,
): Promise<TdmSupplier> => {
  return customFetch<TdmSupplier>(getMergeSupplierUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mergeSupplierRequest),
  });
};

export const getMergeSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeSupplier>>,
    TError,
    { id: string; data: BodyType<MergeSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeSupplier>>,
  TError,
  { id: string; data: BodyType<MergeSupplierRequest> },
  TContext
> => {
  const mutationKey = ["mergeSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeSupplier>>,
    { id: string; data: BodyType<MergeSupplierRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return mergeSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeSupplier>>
>;
export type MergeSupplierMutationBody = BodyType<MergeSupplierRequest>;
export type MergeSupplierMutationError = ErrorType<unknown>;

/**
 * @summary Merge this supplier into another, soft-deleting this one (admin only)
 */
export const useMergeSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeSupplier>>,
    TError,
    { id: string; data: BodyType<MergeSupplierRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mergeSupplier>>,
  TError,
  { id: string; data: BodyType<MergeSupplierRequest> },
  TContext
> => {
  return useMutation(getMergeSupplierMutationOptions(options));
};

/**
 * @summary Dismiss the "Needs review" near-match flag on a supplier (admin only)
 */
export const getDismissSupplierReviewUrl = (id: string) => {
  return `/api/suppliers/${id}/dismiss-review`;
};

export const dismissSupplierReview = async (
  id: string,
  options?: RequestInit,
): Promise<TdmSupplier> => {
  return customFetch<TdmSupplier>(getDismissSupplierReviewUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissSupplierReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissSupplierReview>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissSupplierReview>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissSupplierReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissSupplierReview>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissSupplierReview(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissSupplierReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissSupplierReview>>
>;

export type DismissSupplierReviewMutationError = ErrorType<unknown>;

/**
 * @summary Dismiss the "Needs review" near-match flag on a supplier (admin only)
 */
export const useDismissSupplierReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissSupplierReview>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissSupplierReview>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDismissSupplierReviewMutationOptions(options));
};

/**
 * @summary Send email to SF admin requesting this supplier be added to Salesforce (admin only)
 */
export const getRequestSupplierSfAddUrl = (id: string) => {
  return `/api/suppliers/${id}/request-sf-add`;
};

export const requestSupplierSfAdd = async (
  id: string,
  options?: RequestInit,
): Promise<RequestSupplierSfAdd200> => {
  return customFetch<RequestSupplierSfAdd200>(getRequestSupplierSfAddUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRequestSupplierSfAddMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestSupplierSfAdd>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestSupplierSfAdd>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["requestSupplierSfAdd"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestSupplierSfAdd>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return requestSupplierSfAdd(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestSupplierSfAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestSupplierSfAdd>>
>;

export type RequestSupplierSfAddMutationError = ErrorType<unknown>;

/**
 * @summary Send email to SF admin requesting this supplier be added to Salesforce (admin only)
 */
export const useRequestSupplierSfAdd = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestSupplierSfAdd>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestSupplierSfAdd>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRequestSupplierSfAddMutationOptions(options));
};

export const getUpsertSupplierChannelManagerOverrideUrl = (
  sfAccountId: string,
) => {
  return `/api/suppliers/${sfAccountId}/channel-manager-override`;
};

export const upsertSupplierChannelManagerOverride = async (
  sfAccountId: string,
  channelManagerOverrideRequest: ChannelManagerOverrideRequest,
  options?: RequestInit,
): Promise<Supplier> => {
  return customFetch<Supplier>(
    getUpsertSupplierChannelManagerOverrideUrl(sfAccountId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(channelManagerOverrideRequest),
    },
  );
};

export const getUpsertSupplierChannelManagerOverrideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>,
    TError,
    { sfAccountId: string; data: BodyType<ChannelManagerOverrideRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>,
  TError,
  { sfAccountId: string; data: BodyType<ChannelManagerOverrideRequest> },
  TContext
> => {
  const mutationKey = ["upsertSupplierChannelManagerOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>,
    { sfAccountId: string; data: BodyType<ChannelManagerOverrideRequest> }
  > = (props) => {
    const { sfAccountId, data } = props ?? {};

    return upsertSupplierChannelManagerOverride(
      sfAccountId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertSupplierChannelManagerOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>
>;
export type UpsertSupplierChannelManagerOverrideMutationBody =
  BodyType<ChannelManagerOverrideRequest>;
export type UpsertSupplierChannelManagerOverrideMutationError =
  ErrorType<unknown>;

export const useUpsertSupplierChannelManagerOverride = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>,
    TError,
    { sfAccountId: string; data: BodyType<ChannelManagerOverrideRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertSupplierChannelManagerOverride>>,
  TError,
  { sfAccountId: string; data: BodyType<ChannelManagerOverrideRequest> },
  TContext
> => {
  return useMutation(
    getUpsertSupplierChannelManagerOverrideMutationOptions(options),
  );
};

export const getDeleteSupplierChannelManagerOverrideUrl = (
  sfAccountId: string,
) => {
  return `/api/suppliers/${sfAccountId}/channel-manager-override`;
};

export const deleteSupplierChannelManagerOverride = async (
  sfAccountId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(
    getDeleteSupplierChannelManagerOverrideUrl(sfAccountId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteSupplierChannelManagerOverrideMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>,
    TError,
    { sfAccountId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>,
  TError,
  { sfAccountId: string },
  TContext
> => {
  const mutationKey = ["deleteSupplierChannelManagerOverride"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>,
    { sfAccountId: string }
  > = (props) => {
    const { sfAccountId } = props ?? {};

    return deleteSupplierChannelManagerOverride(sfAccountId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSupplierChannelManagerOverrideMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>
>;

export type DeleteSupplierChannelManagerOverrideMutationError =
  ErrorType<unknown>;

export const useDeleteSupplierChannelManagerOverride = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>,
    TError,
    { sfAccountId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplierChannelManagerOverride>>,
  TError,
  { sfAccountId: string },
  TContext
> => {
  return useMutation(
    getDeleteSupplierChannelManagerOverrideMutationOptions(options),
  );
};

export const getExportRegistrationsCsvUrl = (
  params?: ExportRegistrationsCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/registrations/export?${stringifiedParams}`
    : `/api/admin/registrations/export`;
};

export const exportRegistrationsCsv = async (
  params?: ExportRegistrationsCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportRegistrationsCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getExportRegistrationsCsvQueryKey = (
  params?: ExportRegistrationsCsvParams,
) => {
  return [
    `/api/admin/registrations/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportRegistrationsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportRegistrationsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: ExportRegistrationsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportRegistrationsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportRegistrationsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportRegistrationsCsv>>
  > = ({ signal }) =>
    exportRegistrationsCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportRegistrationsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportRegistrationsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportRegistrationsCsv>>
>;
export type ExportRegistrationsCsvQueryError = ErrorType<unknown>;

export function useExportRegistrationsCsv<
  TData = Awaited<ReturnType<typeof exportRegistrationsCsv>>,
  TError = ErrorType<unknown>,
>(
  params?: ExportRegistrationsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportRegistrationsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportRegistrationsCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get admin-configurable application settings
 */
export const getGetAdminSettingsUrl = () => {
  return `/api/admin/settings`;
};

export const getAdminSettings = async (
  options?: RequestInit,
): Promise<AdminSettings> => {
  return customFetch<AdminSettings>(getGetAdminSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminSettingsQueryKey = () => {
  return [`/api/admin/settings`] as const;
};

export const getGetAdminSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSettings>>
  > = ({ signal }) => getAdminSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSettings>>
>;
export type GetAdminSettingsQueryError = ErrorType<unknown>;

/**
 * @summary Get admin-configurable application settings
 */

export function useGetAdminSettings<
  TData = Awaited<ReturnType<typeof getAdminSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update admin-configurable application settings
 */
export const getUpdateAdminSettingsUrl = () => {
  return `/api/admin/settings`;
};

export const updateAdminSettings = async (
  updateAdminSettingsRequest: UpdateAdminSettingsRequest,
  options?: RequestInit,
): Promise<AdminSettings> => {
  return customFetch<AdminSettings>(getUpdateAdminSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminSettingsRequest),
  });
};

export const getUpdateAdminSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSettings>>,
    TError,
    { data: BodyType<UpdateAdminSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminSettings>>,
  TError,
  { data: BodyType<UpdateAdminSettingsRequest> },
  TContext
> => {
  const mutationKey = ["updateAdminSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminSettings>>,
    { data: BodyType<UpdateAdminSettingsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateAdminSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminSettings>>
>;
export type UpdateAdminSettingsMutationBody =
  BodyType<UpdateAdminSettingsRequest>;
export type UpdateAdminSettingsMutationError = ErrorType<unknown>;

/**
 * @summary Update admin-configurable application settings
 */
export const useUpdateAdminSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminSettings>>,
    TError,
    { data: BodyType<UpdateAdminSettingsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminSettings>>,
  TError,
  { data: BodyType<UpdateAdminSettingsRequest> },
  TContext
> => {
  return useMutation(getUpdateAdminSettingsMutationOptions(options));
};

/**
 * @summary Manually trigger a scheduled-report email send
 */
export const getRunScheduledReportNowUrl = () => {
  return `/api/admin/reports-schedule/run-now`;
};

export const runScheduledReportNow = async (
  runScheduledReportRequest?: RunScheduledReportRequest,
  options?: RequestInit,
): Promise<RunScheduledReportResult> => {
  return customFetch<RunScheduledReportResult>(getRunScheduledReportNowUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(runScheduledReportRequest),
  });
};

export const getRunScheduledReportNowMutationOptions = <
  TError = ErrorType<RunScheduledReportResult>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runScheduledReportNow>>,
    TError,
    { data: BodyType<RunScheduledReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runScheduledReportNow>>,
  TError,
  { data: BodyType<RunScheduledReportRequest> },
  TContext
> => {
  const mutationKey = ["runScheduledReportNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runScheduledReportNow>>,
    { data: BodyType<RunScheduledReportRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return runScheduledReportNow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunScheduledReportNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof runScheduledReportNow>>
>;
export type RunScheduledReportNowMutationBody =
  BodyType<RunScheduledReportRequest>;
export type RunScheduledReportNowMutationError =
  ErrorType<RunScheduledReportResult>;

/**
 * @summary Manually trigger a scheduled-report email send
 */
export const useRunScheduledReportNow = <
  TError = ErrorType<RunScheduledReportResult>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runScheduledReportNow>>,
    TError,
    { data: BodyType<RunScheduledReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runScheduledReportNow>>,
  TError,
  { data: BodyType<RunScheduledReportRequest> },
  TContext
> => {
  return useMutation(getRunScheduledReportNowMutationOptions(options));
};

/**
 * @summary Get the current email provider configuration (secrets masked)
 */
export const getGetEmailProviderConfigUrl = () => {
  return `/api/admin/email-provider`;
};

export const getEmailProviderConfig = async (
  options?: RequestInit,
): Promise<EmailProviderConfig> => {
  return customFetch<EmailProviderConfig>(getGetEmailProviderConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailProviderConfigQueryKey = () => {
  return [`/api/admin/email-provider`] as const;
};

export const getGetEmailProviderConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailProviderConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailProviderConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEmailProviderConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEmailProviderConfig>>
  > = ({ signal }) => getEmailProviderConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailProviderConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailProviderConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailProviderConfig>>
>;
export type GetEmailProviderConfigQueryError = ErrorType<unknown>;

/**
 * @summary Get the current email provider configuration (secrets masked)
 */

export function useGetEmailProviderConfig<
  TData = Awaited<ReturnType<typeof getEmailProviderConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEmailProviderConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailProviderConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save email provider configuration
 */
export const getUpdateEmailProviderConfigUrl = () => {
  return `/api/admin/email-provider`;
};

export const updateEmailProviderConfig = async (
  updateEmailProviderConfigRequest: UpdateEmailProviderConfigRequest,
  options?: RequestInit,
): Promise<EmailProviderConfig> => {
  return customFetch<EmailProviderConfig>(getUpdateEmailProviderConfigUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateEmailProviderConfigRequest),
  });
};

export const getUpdateEmailProviderConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailProviderConfig>>,
    TError,
    { data: BodyType<UpdateEmailProviderConfigRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEmailProviderConfig>>,
  TError,
  { data: BodyType<UpdateEmailProviderConfigRequest> },
  TContext
> => {
  const mutationKey = ["updateEmailProviderConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEmailProviderConfig>>,
    { data: BodyType<UpdateEmailProviderConfigRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateEmailProviderConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEmailProviderConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEmailProviderConfig>>
>;
export type UpdateEmailProviderConfigMutationBody =
  BodyType<UpdateEmailProviderConfigRequest>;
export type UpdateEmailProviderConfigMutationError = ErrorType<unknown>;

/**
 * @summary Save email provider configuration
 */
export const useUpdateEmailProviderConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEmailProviderConfig>>,
    TError,
    { data: BodyType<UpdateEmailProviderConfigRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateEmailProviderConfig>>,
  TError,
  { data: BodyType<UpdateEmailProviderConfigRequest> },
  TContext
> => {
  return useMutation(getUpdateEmailProviderConfigMutationOptions(options));
};

/**
 * @summary Clear the saved email provider configuration (reverts to env-var fallback)
 */
export const getClearEmailProviderConfigUrl = () => {
  return `/api/admin/email-provider`;
};

export const clearEmailProviderConfig = async (
  options?: RequestInit,
): Promise<EmailProviderConfig> => {
  return customFetch<EmailProviderConfig>(getClearEmailProviderConfigUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getClearEmailProviderConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearEmailProviderConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearEmailProviderConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["clearEmailProviderConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearEmailProviderConfig>>,
    void
  > = () => {
    return clearEmailProviderConfig(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearEmailProviderConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearEmailProviderConfig>>
>;

export type ClearEmailProviderConfigMutationError = ErrorType<unknown>;

/**
 * @summary Clear the saved email provider configuration (reverts to env-var fallback)
 */
export const useClearEmailProviderConfig = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearEmailProviderConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearEmailProviderConfig>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getClearEmailProviderConfigMutationOptions(options));
};

/**
 * @summary Send a test email through the currently configured provider
 */
export const getTestEmailProviderSendUrl = () => {
  return `/api/admin/email-provider/test`;
};

export const testEmailProviderSend = async (
  testEmailSendRequest: TestEmailSendRequest,
  options?: RequestInit,
): Promise<TestEmailSendResult> => {
  return customFetch<TestEmailSendResult>(getTestEmailProviderSendUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(testEmailSendRequest),
  });
};

export const getTestEmailProviderSendMutationOptions = <
  TError = ErrorType<TestEmailSendResult>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testEmailProviderSend>>,
    TError,
    { data: BodyType<TestEmailSendRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testEmailProviderSend>>,
  TError,
  { data: BodyType<TestEmailSendRequest> },
  TContext
> => {
  const mutationKey = ["testEmailProviderSend"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testEmailProviderSend>>,
    { data: BodyType<TestEmailSendRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return testEmailProviderSend(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestEmailProviderSendMutationResult = NonNullable<
  Awaited<ReturnType<typeof testEmailProviderSend>>
>;
export type TestEmailProviderSendMutationBody = BodyType<TestEmailSendRequest>;
export type TestEmailProviderSendMutationError = ErrorType<TestEmailSendResult>;

/**
 * @summary Send a test email through the currently configured provider
 */
export const useTestEmailProviderSend = <
  TError = ErrorType<TestEmailSendResult>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testEmailProviderSend>>,
    TError,
    { data: BodyType<TestEmailSendRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testEmailProviderSend>>,
  TError,
  { data: BodyType<TestEmailSendRequest> },
  TContext
> => {
  return useMutation(getTestEmailProviderSendMutationOptions(options));
};

/**
 * @summary Wipe all DEMO- prefixed records and re-run the seed script
 */
export const getResetDemoDataUrl = () => {
  return `/api/admin/demo-data/reset`;
};

export const resetDemoData = async (
  options?: RequestInit,
): Promise<DemoDataResetResult> => {
  return customFetch<DemoDataResetResult>(getResetDemoDataUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResetDemoDataMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetDemoData>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetDemoData>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resetDemoData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetDemoData>>,
    void
  > = () => {
    return resetDemoData(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetDemoDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetDemoData>>
>;

export type ResetDemoDataMutationError = ErrorType<unknown>;

/**
 * @summary Wipe all DEMO- prefixed records and re-run the seed script
 */
export const useResetDemoData = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetDemoData>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetDemoData>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResetDemoDataMutationOptions(options));
};

/**
 * @summary List all products in the catalog
 */
export const getListCatalogProductsUrl = () => {
  return `/api/admin/catalog/products`;
};

export const listCatalogProducts = async (
  options?: RequestInit,
): Promise<CatalogProduct[]> => {
  return customFetch<CatalogProduct[]>(getListCatalogProductsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCatalogProductsQueryKey = () => {
  return [`/api/admin/catalog/products`] as const;
};

export const getListCatalogProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCatalogProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCatalogProducts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCatalogProductsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCatalogProducts>>
  > = ({ signal }) => listCatalogProducts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCatalogProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCatalogProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCatalogProducts>>
>;
export type ListCatalogProductsQueryError = ErrorType<unknown>;

/**
 * @summary List all products in the catalog
 */

export function useListCatalogProducts<
  TData = Awaited<ReturnType<typeof listCatalogProducts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCatalogProducts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCatalogProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new product in the catalog
 */
export const getCreateCatalogProductUrl = () => {
  return `/api/admin/catalog/products`;
};

export const createCatalogProduct = async (
  createCatalogProductRequest: CreateCatalogProductRequest,
  options?: RequestInit,
): Promise<CatalogProduct> => {
  return customFetch<CatalogProduct>(getCreateCatalogProductUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCatalogProductRequest),
  });
};

export const getCreateCatalogProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCatalogProduct>>,
    TError,
    { data: BodyType<CreateCatalogProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCatalogProduct>>,
  TError,
  { data: BodyType<CreateCatalogProductRequest> },
  TContext
> => {
  const mutationKey = ["createCatalogProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCatalogProduct>>,
    { data: BodyType<CreateCatalogProductRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createCatalogProduct(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCatalogProduct>>
>;
export type CreateCatalogProductMutationBody =
  BodyType<CreateCatalogProductRequest>;
export type CreateCatalogProductMutationError = ErrorType<unknown>;

/**
 * @summary Create a new product in the catalog
 */
export const useCreateCatalogProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCatalogProduct>>,
    TError,
    { data: BodyType<CreateCatalogProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCatalogProduct>>,
  TError,
  { data: BodyType<CreateCatalogProductRequest> },
  TContext
> => {
  return useMutation(getCreateCatalogProductMutationOptions(options));
};

/**
 * @summary Bulk-add multiple products to the catalog
 */
export const getBulkAddCatalogProductsUrl = () => {
  return `/api/admin/catalog/products/bulk`;
};

export const bulkAddCatalogProducts = async (
  bulkAddCatalogProductsRequest: BulkAddCatalogProductsRequest,
  options?: RequestInit,
): Promise<BulkAddCatalogProductsResult> => {
  return customFetch<BulkAddCatalogProductsResult>(
    getBulkAddCatalogProductsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkAddCatalogProductsRequest),
    },
  );
};

export const getBulkAddCatalogProductsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAddCatalogProducts>>,
    TError,
    { data: BodyType<BulkAddCatalogProductsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkAddCatalogProducts>>,
  TError,
  { data: BodyType<BulkAddCatalogProductsRequest> },
  TContext
> => {
  const mutationKey = ["bulkAddCatalogProducts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkAddCatalogProducts>>,
    { data: BodyType<BulkAddCatalogProductsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkAddCatalogProducts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkAddCatalogProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkAddCatalogProducts>>
>;
export type BulkAddCatalogProductsMutationBody =
  BodyType<BulkAddCatalogProductsRequest>;
export type BulkAddCatalogProductsMutationError = ErrorType<unknown>;

/**
 * @summary Bulk-add multiple products to the catalog
 */
export const useBulkAddCatalogProducts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkAddCatalogProducts>>,
    TError,
    { data: BodyType<BulkAddCatalogProductsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkAddCatalogProducts>>,
  TError,
  { data: BodyType<BulkAddCatalogProductsRequest> },
  TContext
> => {
  return useMutation(getBulkAddCatalogProductsMutationOptions(options));
};

/**
 * @summary Preview which names would be added, skipped as duplicates, or invalid
 */
export const getPreviewBulkAddCatalogProductsUrl = () => {
  return `/api/admin/catalog/products/bulk/preview`;
};

export const previewBulkAddCatalogProducts = async (
  bulkAddCatalogProductsRequest: BulkAddCatalogProductsRequest,
  options?: RequestInit,
): Promise<PreviewBulkAddCatalogProductsResult> => {
  return customFetch<PreviewBulkAddCatalogProductsResult>(
    getPreviewBulkAddCatalogProductsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkAddCatalogProductsRequest),
    },
  );
};

export const getPreviewBulkAddCatalogProductsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>,
    TError,
    { data: BodyType<BulkAddCatalogProductsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>,
  TError,
  { data: BodyType<BulkAddCatalogProductsRequest> },
  TContext
> => {
  const mutationKey = ["previewBulkAddCatalogProducts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>,
    { data: BodyType<BulkAddCatalogProductsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return previewBulkAddCatalogProducts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewBulkAddCatalogProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>
>;
export type PreviewBulkAddCatalogProductsMutationBody =
  BodyType<BulkAddCatalogProductsRequest>;
export type PreviewBulkAddCatalogProductsMutationError = ErrorType<unknown>;

/**
 * @summary Preview which names would be added, skipped as duplicates, or invalid
 */
export const usePreviewBulkAddCatalogProducts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>,
    TError,
    { data: BodyType<BulkAddCatalogProductsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewBulkAddCatalogProducts>>,
  TError,
  { data: BodyType<BulkAddCatalogProductsRequest> },
  TContext
> => {
  return useMutation(getPreviewBulkAddCatalogProductsMutationOptions(options));
};

/**
 * @summary Rename a product in the catalog
 */
export const getUpdateCatalogProductUrl = (id: string) => {
  return `/api/admin/catalog/products/${id}`;
};

export const updateCatalogProduct = async (
  id: string,
  updateCatalogProductRequest: UpdateCatalogProductRequest,
  options?: RequestInit,
): Promise<CatalogProduct> => {
  return customFetch<CatalogProduct>(getUpdateCatalogProductUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCatalogProductRequest),
  });
};

export const getUpdateCatalogProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCatalogProduct>>,
    TError,
    { id: string; data: BodyType<UpdateCatalogProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCatalogProduct>>,
  TError,
  { id: string; data: BodyType<UpdateCatalogProductRequest> },
  TContext
> => {
  const mutationKey = ["updateCatalogProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCatalogProduct>>,
    { id: string; data: BodyType<UpdateCatalogProductRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCatalogProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCatalogProduct>>
>;
export type UpdateCatalogProductMutationBody =
  BodyType<UpdateCatalogProductRequest>;
export type UpdateCatalogProductMutationError = ErrorType<unknown>;

/**
 * @summary Rename a product in the catalog
 */
export const useUpdateCatalogProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCatalogProduct>>,
    TError,
    { id: string; data: BodyType<UpdateCatalogProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCatalogProduct>>,
  TError,
  { id: string; data: BodyType<UpdateCatalogProductRequest> },
  TContext
> => {
  return useMutation(getUpdateCatalogProductMutationOptions(options));
};

/**
 * @summary Delete a product from the catalog
 */
export const getDeleteCatalogProductUrl = (id: string) => {
  return `/api/admin/catalog/products/${id}`;
};

export const deleteCatalogProduct = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCatalogProductUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCatalogProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCatalogProduct>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCatalogProduct>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCatalogProduct"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCatalogProduct>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCatalogProduct(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCatalogProduct>>
>;

export type DeleteCatalogProductMutationError = ErrorType<unknown>;

/**
 * @summary Delete a product from the catalog
 */
export const useDeleteCatalogProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCatalogProduct>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCatalogProduct>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCatalogProductMutationOptions(options));
};

/**
 * @summary Get DB pool metrics and recent slow query stats (admin only)
 */
export const getGetDbHealthUrl = () => {
  return `/api/admin/db-health`;
};

export const getDbHealth = async (
  options?: RequestInit,
): Promise<DbHealthSnapshot> => {
  return customFetch<DbHealthSnapshot>(getGetDbHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDbHealthQueryKey = () => {
  return [`/api/admin/db-health`] as const;
};

export const getGetDbHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getDbHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDbHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDbHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDbHealth>>> = ({
    signal,
  }) => getDbHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDbHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDbHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDbHealth>>
>;
export type GetDbHealthQueryError = ErrorType<unknown>;

/**
 * @summary Get DB pool metrics and recent slow query stats (admin only)
 */

export function useGetDbHealth<
  TData = Awaited<ReturnType<typeof getDbHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDbHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDbHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get system health status for all integrations (admin only, cached ~30s)
 */
export const getGetSystemHealthUrl = () => {
  return `/api/admin/system-health`;
};

export const getSystemHealth = async (
  options?: RequestInit,
): Promise<SystemHealthReport> => {
  return customFetch<SystemHealthReport>(getGetSystemHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSystemHealthQueryKey = () => {
  return [`/api/admin/system-health`] as const;
};

export const getGetSystemHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSystemHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSystemHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemHealth>>> = ({
    signal,
  }) => getSystemHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSystemHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSystemHealth>>
>;
export type GetSystemHealthQueryError = ErrorType<unknown>;

/**
 * @summary Get system health status for all integrations (admin only, cached ~30s)
 */

export function useGetSystemHealth<
  TData = Awaited<ReturnType<typeof getSystemHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSystemHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSystemHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Clear the health cache and re-run all checks immediately (admin only)
 */
export const getRefreshSystemHealthUrl = () => {
  return `/api/admin/system-health/refresh`;
};

export const refreshSystemHealth = async (
  options?: RequestInit,
): Promise<SystemHealthReport> => {
  return customFetch<SystemHealthReport>(getRefreshSystemHealthUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshSystemHealthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSystemHealth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshSystemHealth>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshSystemHealth"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshSystemHealth>>,
    void
  > = () => {
    return refreshSystemHealth(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshSystemHealthMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshSystemHealth>>
>;

export type RefreshSystemHealthMutationError = ErrorType<unknown>;

/**
 * @summary Clear the health cache and re-run all checks immediately (admin only)
 */
export const useRefreshSystemHealth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSystemHealth>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshSystemHealth>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshSystemHealthMutationOptions(options));
};

/**
 * @summary Get the built-in MCP server status and base URL
 */
export const getGetAdminMcpStatusUrl = () => {
  return `/api/admin/mcp/status`;
};

export const getAdminMcpStatus = async (
  options?: RequestInit,
): Promise<BuiltInMcpStatus> => {
  return customFetch<BuiltInMcpStatus>(getGetAdminMcpStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminMcpStatusQueryKey = () => {
  return [`/api/admin/mcp/status`] as const;
};

export const getGetAdminMcpStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMcpStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMcpStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMcpStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminMcpStatus>>
  > = ({ signal }) => getAdminMcpStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMcpStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminMcpStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMcpStatus>>
>;
export type GetAdminMcpStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get the built-in MCP server status and base URL
 */

export function useGetAdminMcpStatus<
  TData = Awaited<ReturnType<typeof getAdminMcpStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMcpStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminMcpStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Ping the built-in MCP server health endpoint
 */
export const getTestAdminMcpUrl = () => {
  return `/api/admin/mcp/test`;
};

export const testAdminMcp = async (
  options?: RequestInit,
): Promise<BuiltInMcpStatus> => {
  return customFetch<BuiltInMcpStatus>(getTestAdminMcpUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestAdminMcpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminMcp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminMcp>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testAdminMcp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminMcp>>,
    void
  > = () => {
    return testAdminMcp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminMcpMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminMcp>>
>;

export type TestAdminMcpMutationError = ErrorType<unknown>;

/**
 * @summary Ping the built-in MCP server health endpoint
 */
export const useTestAdminMcp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminMcp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminMcp>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestAdminMcpMutationOptions(options));
};

/**
 * @summary List registered external MCP servers
 */
export const getListExternalMcpServersUrl = () => {
  return `/api/admin/mcp/servers`;
};

export const listExternalMcpServers = async (
  options?: RequestInit,
): Promise<ExternalMcpServer[]> => {
  return customFetch<ExternalMcpServer[]>(getListExternalMcpServersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListExternalMcpServersQueryKey = () => {
  return [`/api/admin/mcp/servers`] as const;
};

export const getListExternalMcpServersQueryOptions = <
  TData = Awaited<ReturnType<typeof listExternalMcpServers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listExternalMcpServers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExternalMcpServersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExternalMcpServers>>
  > = ({ signal }) => listExternalMcpServers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExternalMcpServers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExternalMcpServersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExternalMcpServers>>
>;
export type ListExternalMcpServersQueryError = ErrorType<unknown>;

/**
 * @summary List registered external MCP servers
 */

export function useListExternalMcpServers<
  TData = Awaited<ReturnType<typeof listExternalMcpServers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listExternalMcpServers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExternalMcpServersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new external MCP server
 */
export const getCreateExternalMcpServerUrl = () => {
  return `/api/admin/mcp/servers`;
};

export const createExternalMcpServer = async (
  createExternalMcpServerRequest: CreateExternalMcpServerRequest,
  options?: RequestInit,
): Promise<ExternalMcpServer> => {
  return customFetch<ExternalMcpServer>(getCreateExternalMcpServerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createExternalMcpServerRequest),
  });
};

export const getCreateExternalMcpServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExternalMcpServer>>,
    TError,
    { data: BodyType<CreateExternalMcpServerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExternalMcpServer>>,
  TError,
  { data: BodyType<CreateExternalMcpServerRequest> },
  TContext
> => {
  const mutationKey = ["createExternalMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExternalMcpServer>>,
    { data: BodyType<CreateExternalMcpServerRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createExternalMcpServer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExternalMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExternalMcpServer>>
>;
export type CreateExternalMcpServerMutationBody =
  BodyType<CreateExternalMcpServerRequest>;
export type CreateExternalMcpServerMutationError = ErrorType<unknown>;

/**
 * @summary Register a new external MCP server
 */
export const useCreateExternalMcpServer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExternalMcpServer>>,
    TError,
    { data: BodyType<CreateExternalMcpServerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExternalMcpServer>>,
  TError,
  { data: BodyType<CreateExternalMcpServerRequest> },
  TContext
> => {
  return useMutation(getCreateExternalMcpServerMutationOptions(options));
};

/**
 * @summary Update a registered external MCP server
 */
export const getUpdateExternalMcpServerUrl = (id: string) => {
  return `/api/admin/mcp/servers/${id}`;
};

export const updateExternalMcpServer = async (
  id: string,
  updateExternalMcpServerRequest: UpdateExternalMcpServerRequest,
  options?: RequestInit,
): Promise<ExternalMcpServer> => {
  return customFetch<ExternalMcpServer>(getUpdateExternalMcpServerUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateExternalMcpServerRequest),
  });
};

export const getUpdateExternalMcpServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExternalMcpServer>>,
    TError,
    { id: string; data: BodyType<UpdateExternalMcpServerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExternalMcpServer>>,
  TError,
  { id: string; data: BodyType<UpdateExternalMcpServerRequest> },
  TContext
> => {
  const mutationKey = ["updateExternalMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExternalMcpServer>>,
    { id: string; data: BodyType<UpdateExternalMcpServerRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExternalMcpServer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExternalMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExternalMcpServer>>
>;
export type UpdateExternalMcpServerMutationBody =
  BodyType<UpdateExternalMcpServerRequest>;
export type UpdateExternalMcpServerMutationError = ErrorType<unknown>;

/**
 * @summary Update a registered external MCP server
 */
export const useUpdateExternalMcpServer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExternalMcpServer>>,
    TError,
    { id: string; data: BodyType<UpdateExternalMcpServerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateExternalMcpServer>>,
  TError,
  { id: string; data: BodyType<UpdateExternalMcpServerRequest> },
  TContext
> => {
  return useMutation(getUpdateExternalMcpServerMutationOptions(options));
};

/**
 * @summary Delete a registered external MCP server
 */
export const getDeleteExternalMcpServerUrl = (id: string) => {
  return `/api/admin/mcp/servers/${id}`;
};

export const deleteExternalMcpServer = async (
  id: string,
  options?: RequestInit,
): Promise<DeleteExternalMcpServer200> => {
  return customFetch<DeleteExternalMcpServer200>(
    getDeleteExternalMcpServerUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteExternalMcpServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExternalMcpServer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExternalMcpServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteExternalMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExternalMcpServer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteExternalMcpServer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExternalMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExternalMcpServer>>
>;

export type DeleteExternalMcpServerMutationError = ErrorType<unknown>;

/**
 * @summary Delete a registered external MCP server
 */
export const useDeleteExternalMcpServer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExternalMcpServer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteExternalMcpServer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteExternalMcpServerMutationOptions(options));
};

/**
 * @summary Test the connection to a registered external MCP server
 */
export const getTestExternalMcpServerUrl = (id: string) => {
  return `/api/admin/mcp/servers/${id}/test`;
};

export const testExternalMcpServer = async (
  id: string,
  options?: RequestInit,
): Promise<ExternalMcpTestResult> => {
  return customFetch<ExternalMcpTestResult>(getTestExternalMcpServerUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getTestExternalMcpServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testExternalMcpServer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testExternalMcpServer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["testExternalMcpServer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testExternalMcpServer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return testExternalMcpServer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestExternalMcpServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof testExternalMcpServer>>
>;

export type TestExternalMcpServerMutationError = ErrorType<unknown>;

/**
 * @summary Test the connection to a registered external MCP server
 */
export const useTestExternalMcpServer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testExternalMcpServer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testExternalMcpServer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getTestExternalMcpServerMutationOptions(options));
};

/**
 * @summary List MCP API tokens (admin only)
 */
export const getListMcpTokensUrl = () => {
  return `/api/admin/mcp/tokens`;
};

export const listMcpTokens = async (
  options?: RequestInit,
): Promise<McpToken[]> => {
  return customFetch<McpToken[]>(getListMcpTokensUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMcpTokensQueryKey = () => {
  return [`/api/admin/mcp/tokens`] as const;
};

export const getListMcpTokensQueryOptions = <
  TData = Awaited<ReturnType<typeof listMcpTokens>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMcpTokens>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMcpTokensQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMcpTokens>>> = ({
    signal,
  }) => listMcpTokens({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMcpTokens>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMcpTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMcpTokens>>
>;
export type ListMcpTokensQueryError = ErrorType<unknown>;

/**
 * @summary List MCP API tokens (admin only)
 */

export function useListMcpTokens<
  TData = Awaited<ReturnType<typeof listMcpTokens>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMcpTokens>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMcpTokensQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mint a new MCP API token for a user (admin only)
 */
export const getCreateMcpTokenUrl = () => {
  return `/api/admin/mcp/tokens`;
};

export const createMcpToken = async (
  createMcpTokenRequest: CreateMcpTokenRequest,
  options?: RequestInit,
): Promise<CreateMcpTokenResult> => {
  return customFetch<CreateMcpTokenResult>(getCreateMcpTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMcpTokenRequest),
  });
};

export const getCreateMcpTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMcpToken>>,
    TError,
    { data: BodyType<CreateMcpTokenRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMcpToken>>,
  TError,
  { data: BodyType<CreateMcpTokenRequest> },
  TContext
> => {
  const mutationKey = ["createMcpToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMcpToken>>,
    { data: BodyType<CreateMcpTokenRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createMcpToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMcpTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMcpToken>>
>;
export type CreateMcpTokenMutationBody = BodyType<CreateMcpTokenRequest>;
export type CreateMcpTokenMutationError = ErrorType<unknown>;

/**
 * @summary Mint a new MCP API token for a user (admin only)
 */
export const useCreateMcpToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMcpToken>>,
    TError,
    { data: BodyType<CreateMcpTokenRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMcpToken>>,
  TError,
  { data: BodyType<CreateMcpTokenRequest> },
  TContext
> => {
  return useMutation(getCreateMcpTokenMutationOptions(options));
};

/**
 * @summary Revoke an MCP API token (admin only)
 */
export const getRevokeMcpTokenUrl = (id: string) => {
  return `/api/admin/mcp/tokens/${id}`;
};

export const revokeMcpToken = async (
  id: string,
  options?: RequestInit,
): Promise<RevokeMcpToken200> => {
  return customFetch<RevokeMcpToken200>(getRevokeMcpTokenUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeMcpTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeMcpToken>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeMcpToken>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["revokeMcpToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeMcpToken>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return revokeMcpToken(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeMcpTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeMcpToken>>
>;

export type RevokeMcpTokenMutationError = ErrorType<unknown>;

/**
 * @summary Revoke an MCP API token (admin only)
 */
export const useRevokeMcpToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeMcpToken>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeMcpToken>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRevokeMcpTokenMutationOptions(options));
};

/**
 * @summary List admin audit log entries (admin only)
 */
export const getListAuditLogUrl = (params?: ListAuditLogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/audit-log?${stringifiedParams}`
    : `/api/admin/audit-log`;
};

export const listAuditLog = async (
  params?: ListAuditLogParams,
  options?: RequestInit,
): Promise<ListAuditLogResult> => {
  return customFetch<ListAuditLogResult>(getListAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAuditLogQueryKey = (params?: ListAuditLogParams) => {
  return [`/api/admin/audit-log`, ...(params ? [params] : [])] as const;
};

export const getListAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLog>>> = ({
    signal,
  }) => listAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAuditLog>>
>;
export type ListAuditLogQueryError = ErrorType<unknown>;

/**
 * @summary List admin audit log entries (admin only)
 */

export function useListAuditLog<
  TData = Awaited<ReturnType<typeof listAuditLog>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List users (admin only) for token management dropdowns
 */
export const getListAdminUsersUrl = () => {
  return `/api/admin/users`;
};

export const listAdminUsers = async (
  options?: RequestInit,
): Promise<AdminUser[]> => {
  return customFetch<AdminUser[]>(getListAdminUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminUsersQueryKey = () => {
  return [`/api/admin/users`] as const;
};

export const getListAdminUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({
    signal,
  }) => listAdminUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminUsers>>
>;
export type ListAdminUsersQueryError = ErrorType<unknown>;

/**
 * @summary List users (admin only) for token management dropdowns
 */

export function useListAdminUsers<
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a user's admin status (admin only)
 */
export const getUpdateAdminUserUrl = (id: string) => {
  return `/api/admin/users/${id}`;
};

export const updateAdminUser = async (
  id: string,
  updateAdminUserRequest: UpdateAdminUserRequest,
  options?: RequestInit,
): Promise<AdminUser> => {
  return customFetch<AdminUser>(getUpdateAdminUserUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAdminUserRequest),
  });
};

export const getUpdateAdminUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminUser>>,
    TError,
    { id: string; data: BodyType<UpdateAdminUserRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminUser>>,
  TError,
  { id: string; data: BodyType<UpdateAdminUserRequest> },
  TContext
> => {
  const mutationKey = ["updateAdminUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminUser>>,
    { id: string; data: BodyType<UpdateAdminUserRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAdminUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminUser>>
>;
export type UpdateAdminUserMutationBody = BodyType<UpdateAdminUserRequest>;
export type UpdateAdminUserMutationError = ErrorType<unknown>;

/**
 * @summary Update a user's admin status (admin only)
 */
export const useUpdateAdminUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminUser>>,
    TError,
    { id: string; data: BodyType<UpdateAdminUserRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminUser>>,
  TError,
  { id: string; data: BodyType<UpdateAdminUserRequest> },
  TContext
> => {
  return useMutation(getUpdateAdminUserMutationOptions(options));
};

/**
 * @summary Request a presigned URL to upload a file
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResult> => {
  return customFetch<UploadUrlResult>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<unknown>;

/**
 * @summary Request a presigned URL to upload a file
 */
export const useRequestUploadUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Download a stored object
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<unknown>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<unknown>;

/**
 * @summary Download a stored object
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<unknown>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the current user's support tickets
 */
export const getListMyTicketsUrl = () => {
  return `/api/support/tickets`;
};

export const listMyTickets = async (
  options?: RequestInit,
): Promise<SupportTicket[]> => {
  return customFetch<SupportTicket[]>(getListMyTicketsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyTicketsQueryKey = () => {
  return [`/api/support/tickets`] as const;
};

export const getListMyTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyTickets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyTickets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyTicketsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTickets>>> = ({
    signal,
  }) => listMyTickets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyTickets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyTickets>>
>;
export type ListMyTicketsQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's support tickets
 */

export function useListMyTickets<
  TData = Awaited<ReturnType<typeof listMyTickets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyTickets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyTicketsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new support ticket
 */
export const getCreateSupportTicketUrl = () => {
  return `/api/support/tickets`;
};

export const createSupportTicket = async (
  createSupportTicketRequest: CreateSupportTicketRequest,
  options?: RequestInit,
): Promise<SupportTicket> => {
  return customFetch<SupportTicket>(getCreateSupportTicketUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSupportTicketRequest),
  });
};

export const getCreateSupportTicketMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupportTicket>>,
    TError,
    { data: BodyType<CreateSupportTicketRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupportTicket>>,
  TError,
  { data: BodyType<CreateSupportTicketRequest> },
  TContext
> => {
  const mutationKey = ["createSupportTicket"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupportTicket>>,
    { data: BodyType<CreateSupportTicketRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createSupportTicket(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupportTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSupportTicket>>
>;
export type CreateSupportTicketMutationBody =
  BodyType<CreateSupportTicketRequest>;
export type CreateSupportTicketMutationError = ErrorType<unknown>;

/**
 * @summary Create a new support ticket
 */
export const useCreateSupportTicket = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupportTicket>>,
    TError,
    { data: BodyType<CreateSupportTicketRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSupportTicket>>,
  TError,
  { data: BodyType<CreateSupportTicketRequest> },
  TContext
> => {
  return useMutation(getCreateSupportTicketMutationOptions(options));
};

/**
 * @summary List all support tickets (admin only)
 */
export const getListAllTicketsUrl = (params?: ListAllTicketsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/support/tickets/admin?${stringifiedParams}`
    : `/api/support/tickets/admin`;
};

export const listAllTickets = async (
  params?: ListAllTicketsParams,
  options?: RequestInit,
): Promise<SupportTicket[]> => {
  return customFetch<SupportTicket[]>(getListAllTicketsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAllTicketsQueryKey = (params?: ListAllTicketsParams) => {
  return [`/api/support/tickets/admin`, ...(params ? [params] : [])] as const;
};

export const getListAllTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllTickets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllTicketsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllTickets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllTicketsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllTickets>>> = ({
    signal,
  }) => listAllTickets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllTickets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAllTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllTickets>>
>;
export type ListAllTicketsQueryError = ErrorType<unknown>;

/**
 * @summary List all support tickets (admin only)
 */

export function useListAllTickets<
  TData = Awaited<ReturnType<typeof listAllTickets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAllTicketsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAllTickets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAllTicketsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a support ticket by ID
 */
export const getGetSupportTicketUrl = (id: string) => {
  return `/api/support/tickets/${id}`;
};

export const getSupportTicket = async (
  id: string,
  options?: RequestInit,
): Promise<SupportTicketDetail> => {
  return customFetch<SupportTicketDetail>(getGetSupportTicketUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSupportTicketQueryKey = (id: string) => {
  return [`/api/support/tickets/${id}`] as const;
};

export const getGetSupportTicketQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSupportTicket>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSupportTicketQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSupportTicket>>
  > = ({ signal }) => getSupportTicket(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupportTicket>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSupportTicketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupportTicket>>
>;
export type GetSupportTicketQueryError = ErrorType<unknown>;

/**
 * @summary Get a support ticket by ID
 */

export function useGetSupportTicket<
  TData = Awaited<ReturnType<typeof getSupportTicket>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSupportTicket>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSupportTicketQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update ticket status (admin only)
 */
export const getUpdateTicketStatusUrl = (id: string) => {
  return `/api/support/tickets/${id}/status`;
};

export const updateTicketStatus = async (
  id: string,
  updateTicketStatusRequest: UpdateTicketStatusRequest,
  options?: RequestInit,
): Promise<SupportTicket> => {
  return customFetch<SupportTicket>(getUpdateTicketStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTicketStatusRequest),
  });
};

export const getUpdateTicketStatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTicketStatus>>,
    TError,
    { id: string; data: BodyType<UpdateTicketStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTicketStatus>>,
  TError,
  { id: string; data: BodyType<UpdateTicketStatusRequest> },
  TContext
> => {
  const mutationKey = ["updateTicketStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTicketStatus>>,
    { id: string; data: BodyType<UpdateTicketStatusRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTicketStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTicketStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTicketStatus>>
>;
export type UpdateTicketStatusMutationBody =
  BodyType<UpdateTicketStatusRequest>;
export type UpdateTicketStatusMutationError = ErrorType<unknown>;

/**
 * @summary Update ticket status (admin only)
 */
export const useUpdateTicketStatus = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTicketStatus>>,
    TError,
    { id: string; data: BodyType<UpdateTicketStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTicketStatus>>,
  TError,
  { id: string; data: BodyType<UpdateTicketStatusRequest> },
  TContext
> => {
  return useMutation(getUpdateTicketStatusMutationOptions(options));
};

/**
 * @summary Add a message/reply to a ticket
 */
export const getAddTicketMessageUrl = (id: string) => {
  return `/api/support/tickets/${id}/messages`;
};

export const addTicketMessage = async (
  id: string,
  addTicketMessageRequest: AddTicketMessageRequest,
  options?: RequestInit,
): Promise<SupportTicketMessage> => {
  return customFetch<SupportTicketMessage>(getAddTicketMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addTicketMessageRequest),
  });
};

export const getAddTicketMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTicketMessage>>,
    TError,
    { id: string; data: BodyType<AddTicketMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTicketMessage>>,
  TError,
  { id: string; data: BodyType<AddTicketMessageRequest> },
  TContext
> => {
  const mutationKey = ["addTicketMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTicketMessage>>,
    { id: string; data: BodyType<AddTicketMessageRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addTicketMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTicketMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTicketMessage>>
>;
export type AddTicketMessageMutationBody = BodyType<AddTicketMessageRequest>;
export type AddTicketMessageMutationError = ErrorType<unknown>;

/**
 * @summary Add a message/reply to a ticket
 */
export const useAddTicketMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTicketMessage>>,
    TError,
    { id: string; data: BodyType<AddTicketMessageRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addTicketMessage>>,
  TError,
  { id: string; data: BodyType<AddTicketMessageRequest> },
  TContext
> => {
  return useMutation(getAddTicketMessageMutationOptions(options));
};
